import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import {
  LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer, ComposedChart, Area, AreaChart,
} from 'recharts';
import {
  MapPin, Droplet, Trees, TrendingUp, Users, Zap, LogOut, FileText,
  BarChart3, Map as MapIcon, Filter, ChevronRight, AlertTriangle, Layers,
  Download,
} from 'lucide-react';
import { mapTilerKey } from '../Constants';
import LegacyAskiDashboard from './LegacyAskiDashboard';
import styles from './NewAskiDashboard.module.css';
import { jsPDF } from 'jspdf';
import { geeService } from '../../services/geeService';

const maplibregl = window.maplibregl;

const HAVZA_BOUNDARIES = [
  { id: 1, color: '#3b82f6', coords: [[32.65,39.92],[32.75,39.96],[32.82,39.98],[32.85,39.95],[32.83,39.88],[32.72,39.86],[32.65,39.88],[32.65,39.92]] },
  { id: 2, color: '#10b981', coords: [[32.75,39.96],[32.88,40.00],[32.95,39.98],[32.95,39.92],[32.85,39.88],[32.82,39.90],[32.82,39.98],[32.75,39.96]] },
  { id: 3, color: '#f59e0b', coords: [[32.82,39.98],[32.95,40.02],[33.05,40.00],[33.05,39.90],[32.95,39.85],[32.88,39.85],[32.85,39.88],[32.85,39.95],[32.82,39.98]] },
];

const BOLGE_COORDS = {
  101: { center: [32.71, 39.89], bounds: [[32.68,39.87],[32.74,39.87],[32.74,39.91],[32.68,39.91],[32.68,39.87]] },
  102: { center: [32.85, 39.93], bounds: [[32.83,39.92],[32.87,39.92],[32.87,39.94],[32.83,39.94],[32.83,39.92]] },
  103: { center: [32.82, 39.91], bounds: [[32.80,39.90],[32.84,39.90],[32.84,39.92],[32.80,39.92],[32.80,39.90]] },
  104: { center: [32.84, 39.92], bounds: [[32.83,39.91],[32.86,39.91],[32.86,39.93],[32.83,39.93],[32.83,39.91]] },
  105: { center: [32.73, 39.88], bounds: [[32.71,39.87],[32.75,39.87],[32.75,39.89],[32.71,39.89],[32.71,39.87]] },
  201: { center: [32.68, 39.95], bounds: [[32.65,39.94],[32.71,39.94],[32.71,39.96],[32.65,39.96],[32.65,39.94]] },
  202: { center: [32.70, 39.94], bounds: [[32.68,39.93],[32.72,39.93],[32.72,39.95],[32.68,39.95],[32.68,39.93]] },
  203: { center: [32.66, 39.92], bounds: [[32.64,39.91],[32.68,39.91],[32.68,39.93],[32.64,39.93],[32.64,39.91]] },
  204: { center: [32.72, 39.96], bounds: [[32.70,39.95],[32.74,39.95],[32.74,39.97],[32.70,39.97],[32.70,39.95]] },
  301: { center: [32.76, 39.97], bounds: [[32.74,39.96],[32.78,39.96],[32.78,39.98],[32.74,39.98],[32.74,39.96]] },
  302: { center: [32.80, 39.95], bounds: [[32.78,39.94],[32.82,39.94],[32.82,39.96],[32.78,39.96],[32.78,39.94]] },
  303: { center: [32.82, 39.96], bounds: [[32.80,39.95],[32.84,39.95],[32.84,39.97],[32.80,39.97],[32.80,39.95]] },
  304: { center: [32.78, 39.98], bounds: [[32.76,39.97],[32.80,39.97],[32.80,39.99],[32.76,39.99],[32.76,39.97]] },
  401: { center: [32.88, 39.96], bounds: [[32.86,39.95],[32.90,39.95],[32.90,39.97],[32.86,39.97],[32.86,39.95]] },
  402: { center: [32.87, 39.94], bounds: [[32.85,39.93],[32.89,39.93],[32.89,39.95],[32.85,39.95],[32.85,39.93]] },
  403: { center: [32.90, 39.97], bounds: [[32.88,39.96],[32.92,39.96],[32.92,39.98],[32.88,39.98],[32.88,39.96]] },
  404: { center: [32.86, 39.98], bounds: [[32.84,39.97],[32.88,39.97],[32.88,39.99],[32.84,39.99],[32.84,39.97]] },
  501: { center: [32.92, 39.92], bounds: [[32.90,39.91],[32.94,39.91],[32.94,39.93],[32.90,39.93],[32.90,39.91]] },
  502: { center: [32.90, 39.93], bounds: [[32.88,39.92],[32.92,39.92],[32.92,39.94],[32.88,39.94],[32.88,39.92]] },
  503: { center: [32.88, 39.92], bounds: [[32.87,39.91],[32.90,39.91],[32.90,39.93],[32.87,39.93],[32.87,39.91]] },
  601: { center: [32.58, 39.97], bounds: [[32.55,39.96],[32.61,39.96],[32.61,39.98],[32.55,39.98],[32.55,39.96]] },
  602: { center: [32.60, 39.95], bounds: [[32.58,39.94],[32.62,39.94],[32.62,39.96],[32.58,39.96],[32.58,39.94]] },
  603: { center: [32.55, 39.93], bounds: [[32.53,39.92],[32.57,39.92],[32.57,39.94],[32.53,39.94],[32.53,39.92]] },
  701: { center: [32.90, 40.01], bounds: [[32.88,40.00],[32.92,40.00],[32.92,40.02],[32.88,40.02],[32.88,40.00]] },
  702: { center: [32.93, 40.02], bounds: [[32.91,40.01],[32.95,40.01],[32.95,40.03],[32.91,40.03],[32.91,40.01]] },
};

const HAVZALAR = [
  { id: 1, name: '1. Havza', coverage: [
    { ilceId: 1, oran: 0.70 },
    { ilceId: 2, oran: 0.40 },
    { ilceId: 3, oran: 0.25 },
  ]},
  { id: 2, name: '2. Havza', coverage: [
    { ilceId: 1, oran: 0.30 },
    { ilceId: 2, oran: 0.60 },
    { ilceId: 3, oran: 0.50 },
    { ilceId: 4, oran: 0.35 },
  ]},
  { id: 3, name: '3. Havza', coverage: [
    { ilceId: 3, oran: 0.25 },
    { ilceId: 4, oran: 0.65 },
    { ilceId: 5, oran: 1.00 },
    { ilceId: 6, oran: 1.00 },
    { ilceId: 7, oran: 1.00 },
  ]},
];

const ILCELER = [
  { id: 1, name: 'Çankaya', nufus: 920000, bolgeler: [
    { id: 101, name: 'Çayyolu', parkSayisi: 85, parkAlani: 180000, yesilAlan: 160000, suTuketimi: 420000 },
    { id: 102, name: 'Kızılay', parkSayisi: 35, parkAlani: 45000, yesilAlan: 38000, suTuketimi: 110000 },
    { id: 103, name: 'Bahçelievler', parkSayisi: 60, parkAlani: 95000, yesilAlan: 82000, suTuketimi: 230000 },
    { id: 104, name: 'Balgat', parkSayisi: 45, parkAlani: 72000, yesilAlan: 61000, suTuketimi: 175000 },
    { id: 105, name: 'Ümitköy', parkSayisi: 70, parkAlani: 130000, yesilAlan: 112000, suTuketimi: 310000 },
  ]},
  { id: 2, name: 'Etimesgut', nufus: 620000, bolgeler: [
    { id: 201, name: 'Eryaman', parkSayisi: 95, parkAlani: 200000, yesilAlan: 175000, suTuketimi: 480000 },
    { id: 202, name: 'Elvankent', parkSayisi: 70, parkAlani: 140000, yesilAlan: 120000, suTuketimi: 340000 },
    { id: 203, name: 'Bağlıca', parkSayisi: 55, parkAlani: 110000, yesilAlan: 95000, suTuketimi: 265000 },
    { id: 204, name: 'Etimesgut Merkez', parkSayisi: 40, parkAlani: 65000, yesilAlan: 55000, suTuketimi: 160000 },
  ]},
  { id: 3, name: 'Yenimahalle', nufus: 680000, bolgeler: [
    { id: 301, name: 'Batıkent', parkSayisi: 80, parkAlani: 160000, yesilAlan: 140000, suTuketimi: 390000 },
    { id: 302, name: 'Demetevler', parkSayisi: 50, parkAlani: 80000, yesilAlan: 68000, suTuketimi: 195000 },
    { id: 303, name: 'Ostim', parkSayisi: 30, parkAlani: 48000, yesilAlan: 40000, suTuketimi: 115000 },
    { id: 304, name: 'Şentepe', parkSayisi: 40, parkAlani: 65000, yesilAlan: 55000, suTuketimi: 160000 },
  ]},
  { id: 4, name: 'Keçiören', nufus: 940000, bolgeler: [
    { id: 401, name: 'Etlik', parkSayisi: 55, parkAlani: 90000, yesilAlan: 78000, suTuketimi: 220000 },
    { id: 402, name: 'Esertepe', parkSayisi: 40, parkAlani: 60000, yesilAlan: 50000, suTuketimi: 145000 },
    { id: 403, name: 'Kalaba', parkSayisi: 35, parkAlani: 55000, yesilAlan: 46000, suTuketimi: 130000 },
    { id: 404, name: 'Bağlum', parkSayisi: 45, parkAlani: 80000, yesilAlan: 68000, suTuketimi: 195000 },
  ]},
  { id: 5, name: 'Mamak', nufus: 660000, bolgeler: [
    { id: 501, name: 'Natoyolu', parkSayisi: 40, parkAlani: 65000, yesilAlan: 55000, suTuketimi: 155000 },
    { id: 502, name: 'Abidinpaşa', parkSayisi: 30, parkAlani: 42000, yesilAlan: 35000, suTuketimi: 100000 },
    { id: 503, name: 'Cebeci', parkSayisi: 25, parkAlani: 35000, yesilAlan: 28000, suTuketimi: 82000 },
  ]},
  { id: 6, name: 'Sincan', nufus: 540000, bolgeler: [
    { id: 601, name: 'Sincan Merkez', parkSayisi: 50, parkAlani: 85000, yesilAlan: 72000, suTuketimi: 205000 },
    { id: 602, name: 'Yenikent', parkSayisi: 35, parkAlani: 60000, yesilAlan: 50000, suTuketimi: 145000 },
    { id: 603, name: 'Temelli', parkSayisi: 20, parkAlani: 32000, yesilAlan: 26000, suTuketimi: 75000 },
  ]},
  { id: 7, name: 'Pursaklar', nufus: 160000, bolgeler: [
    { id: 701, name: 'Pursaklar Merkez', parkSayisi: 30, parkAlani: 50000, yesilAlan: 42000, suTuketimi: 120000 },
    { id: 702, name: 'Saray', parkSayisi: 20, parkAlani: 35000, yesilAlan: 28000, suTuketimi: 82000 },
  ]},
];

const generateParks = (bolge) => {
  return Array.from({ length: bolge.parkSayisi }, (_, i) => {
    const area = 2000 + Math.random() * 12000;
    const cimAlani = area * (0.5 + Math.random() * 0.35);
    const idealCons = cimAlani * 2.5;
    const waterCons = idealCons * (0.7 + Math.random() * 0.45);
    const eff = Math.round((idealCons / waterCons) * 100);
    const sayacTipi = Math.random() > 0.4 ? 'GPRS' : 'Mekanik';
    const sulamaTipi = ['Otomatik', 'Manuel'][Math.floor(Math.random() * 2)];
    return {
      id: bolge.id * 1000 + i + 1,
      name: `${bolge.name} Park-${i + 1}`,
      alan: Math.round(area),
      cimAlani: Math.round(cimAlani),
      suTuketimi: Math.round(waterCons),
      verimlilik: Math.min(120, Math.max(50, eff)),
      sayacTipi,
      sulamaTipi,
    };
  });
};

const PARK_CACHE = {};
const getParksForBolge = (bolgeId) => {
  if (!PARK_CACHE[bolgeId]) {
    const ilce = ILCELER.find(i => i.bolgeler.some(b => b.id === bolgeId));
    const bolge = ilce?.bolgeler.find(b => b.id === bolgeId);
    if (bolge) PARK_CACHE[bolgeId] = generateParks(bolge);
    else PARK_CACHE[bolgeId] = [];
  }
  return PARK_CACHE[bolgeId];
};

const generateTrend = () => {
  const data = [];
  const base = 8500000;
  for (let y = 2015; y <= 2025; y++) {
    for (let q = 1; q <= 4; q++) {
      const yi = y - 2015;
      let m = 1 + yi * 0.05 + q * 0.01;
      const sv = Math.sin((q - 1) * Math.PI / 2) * 0.08;
      const rv = 0.92 + Math.random() * 0.16;
      m *= (1 + sv) * rv;
      if (y === 2020 && q === 2) m *= 0.72;
      data.push({ period: `${y}/Q${q}`, value: Math.round(base * m) });
    }
  }
  return data;
};

const TREND_DATA = generateTrend();

const AskiDashboard = () => {
  const { user, logout } = useAuth();
  const [showLegacy, setShowLegacy] = useState(false);
  const [selectedIl] = useState('Ankara');
  const [selectedHavza, setSelectedHavza] = useState('');
  const [selectedIlce, setSelectedIlce] = useState('');
  const [selectedBolge, setSelectedBolge] = useState('');
  const [activeTab, setActiveTab] = useState('reports');
  const [chartType, setChartType] = useState('bar');
  const [analysisMetric, setAnalysisMetric] = useState('water_vs_green');
  const mapRef = useRef(null);
  const mapContainerRef = useRef(null);
  const [pdfGenerating, setPdfGenerating] = useState(false);
  const [compareHavzalar, setCompareHavzalar] = useState([]);
  const [mapVisibleHavzalar, setMapVisibleHavzalar] = useState([1,2,3]);
  const [mapVisibleBolgeler, setMapVisibleBolgeler] = useState([]);
  const [mapShowParks, setMapShowParks] = useState(false);
  const [mapLayer, setMapLayer] = useState('havza');

  const [geeReady, setGeeReady] = useState(false);
  const [geeLoading, setGeeLoading] = useState(false);
  const [geeProject, setGeeProject] = useState(process.env.REACT_APP_GEE_PROJECT || '');
  const [ndviPanel, setNdviPanel] = useState(null);
  const [ndviLoading, setNdviLoading] = useState(false);
  const [ndviResults, setNdviResults] = useState({});
  const [showNdviLayer, setShowNdviLayer] = useState(false);

  const handleConnectGEE = async () => {
    try {
      setGeeLoading(true);
      await geeService.initGEEWithProject(geeProject);
      setGeeReady(true);
    } catch (e) {
      alert('GEE baglanti hatasi: ' + e.message);
    } finally {
      setGeeLoading(false);
    }
  };

  const runNDVIForCoords = async (name, coords) => {
    if (!geeReady) return;
    const key = name;
    if (ndviResults[key]) { setNdviPanel(key); return; }
    try {
      setNdviLoading(true);
      setNdviPanel(key);
      const result = await geeService.computeNDVI(coords, '2024-04-01', '2024-10-31', 40, 0.35);
      setNdviResults(prev => ({ ...prev, [key]: { ...result, name, coords } }));
      try {
        const tiles = await geeService.getNDVIMapTiles(coords, '2024-04-01', '2024-10-31');
        const map = mapRef.current;
        if (map && tiles.ndviTileUrl) {
          const srcId = `ndvi-${key.replace(/\s/g, '_')}`;
          if (!map.getSource(srcId)) {
            map.addSource(srcId, { type: 'raster', tiles: [tiles.ndviTileUrl], tileSize: 256 });
            map.addLayer({ id: `ndvi-layer-${srcId}`, type: 'raster', source: srcId, paint: { 'raster-opacity': 0.7 } });
          }
        }
      } catch (tErr) { console.warn('NDVI tile yuklenemedi:', tErr); }
    } catch (e) {
      setNdviResults(prev => ({ ...prev, [key]: { error: e.message, name } }));
    } finally {
      setNdviLoading(false);
    }
  };

  const getNdviColor = (val) => {
    if (val >= 0.6) return '#166534';
    if (val >= 0.4) return '#22c55e';
    if (val >= 0.2) return '#facc15';
    return '#ef4444';
  };
  const getNdviLabel = (val) => {
    if (val >= 0.6) return 'Cok Saglikli';
    if (val >= 0.4) return 'Saglikli';
    if (val >= 0.2) return 'Orta';
    if (val >= 0) return 'Zayif';
    return 'Bitki Yok';
  };

  useEffect(() => {
    if (activeTab === 'map' && mapContainerRef.current && !mapRef.current && maplibregl) {
      const map = new maplibregl.Map({
        container: mapContainerRef.current,
        style: `https://api.maptiler.com/maps/basic-v2/style.json?key=${mapTilerKey}`,
        center: [32.82, 39.94],
        zoom: 10.5,
      });
      map.addControl(new maplibregl.NavigationControl(), 'top-right');
      mapRef.current = map;

      map.on('load', () => {
        HAVZA_BOUNDARIES.forEach(hb => {
          map.addSource(`havza-${hb.id}`, { type: 'geojson', data: { type: 'Feature', geometry: { type: 'Polygon', coordinates: [hb.coords] } } });
          map.addLayer({ id: `havza-fill-${hb.id}`, type: 'fill', source: `havza-${hb.id}`, paint: { 'fill-color': hb.color, 'fill-opacity': 0.12 } });
          map.addLayer({ id: `havza-line-${hb.id}`, type: 'line', source: `havza-${hb.id}`, paint: { 'line-color': hb.color, 'line-width': 3, 'line-dasharray': [4, 2] } });
          const ctr = hb.coords.reduce((a, c) => [a[0]+c[0]/hb.coords.length, a[1]+c[1]/hb.coords.length], [0,0]);
          const h = HAVZALAR.find(x=>x.id===hb.id);
          new maplibregl.Marker({ color: hb.color }).setLngLat(ctr).setPopup(new maplibregl.Popup().setHTML(`<b>${h?.name}</b>`)).addTo(map);
        });

        const bolgeFeatures = Object.entries(BOLGE_COORDS).map(([id, bc]) => ({ type: 'Feature', properties: { id: parseInt(id) }, geometry: { type: 'Polygon', coordinates: [bc.bounds] } }));
        map.addSource('bolgeler', { type: 'geojson', data: { type: 'FeatureCollection', features: bolgeFeatures } });
        map.addLayer({ id: 'bolge-fill', type: 'fill', source: 'bolgeler', paint: { 'fill-color': '#6366f1', 'fill-opacity': 0.2 }, layout: { visibility: 'none' } });
        map.addLayer({ id: 'bolge-line', type: 'line', source: 'bolgeler', paint: { 'line-color': '#6366f1', 'line-width': 2 }, layout: { visibility: 'none' } });

        map.addSource('parks', { type: 'geojson', data: { type: 'FeatureCollection', features: [] } });
        map.addLayer({ id: 'park-circles', type: 'circle', source: 'parks', paint: { 'circle-radius': 5, 'circle-color': '#ef4444', 'circle-stroke-width': 1, 'circle-stroke-color': '#fff' }, layout: { visibility: 'none' } });

        map.on('click', 'park-circles', (e) => {
          const p = e.features[0].properties;
          const cached = ndviResults[p.name];
          const ndviHtml = cached && !cached.error
            ? `<hr style="margin:4px 0;border-color:#e2e8f0"/><span style="color:${getNdviColor(cached.ndviMean)};font-weight:700">NDVI: ${cached.ndviMean?.toFixed(3)}</span><br/><span style="font-size:11px">Yesil: ${cached.greenAreaM2?.toLocaleString()} m² (${cached.greenRatio}%)</span>`
            : geeReady ? `<hr style="margin:4px 0;border-color:#e2e8f0"/><button onclick="window.__runNdviForPark&&window.__runNdviForPark('${p.name}',${p.lng},${p.lat})" style="background:#10b981;color:#fff;border:none;border-radius:4px;padding:3px 8px;font-size:11px;cursor:pointer">NDVI Analiz Et</button>` : '';
          new maplibregl.Popup().setLngLat(e.lngLat).setHTML(`<b>${p.name}</b><br/>Alan: ${p.alan} m²<br/>Su: ${p.suTuketimi} m³${ndviHtml}`).addTo(map);
        });
        map.on('click', 'bolge-fill', (e) => {
          const p = e.features[0].properties;
          const bolgeId = p.id;
          const ilce = ILCELER.find(i => i.bolgeler.some(b => b.id === bolgeId));
          const bolge = ilce?.bolgeler.find(b => b.id === bolgeId);
          if (bolge) new maplibregl.Popup().setLngLat(e.lngLat).setHTML(`<b>${bolge.name}</b><br/>Park: ${bolge.parkSayisi}<br/>Su: ${bolge.suTuketimi.toLocaleString('tr-TR')} m³`).addTo(map);
        });
        map.on('mouseenter', 'park-circles', () => { map.getCanvas().style.cursor = 'pointer'; });
        map.on('mouseleave', 'park-circles', () => { map.getCanvas().style.cursor = ''; });
        map.on('mouseenter', 'bolge-fill', () => { map.getCanvas().style.cursor = 'pointer'; });
        map.on('mouseleave', 'bolge-fill', () => { map.getCanvas().style.cursor = ''; });
      });
    }
    return () => {
      if (mapRef.current && activeTab !== 'map') {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, [activeTab]);

  useEffect(() => {
    const map = mapRef.current;
    if (!map || !map.isStyleLoaded()) return;
    HAVZA_BOUNDARIES.forEach(hb => {
      const vis = mapVisibleHavzalar.includes(hb.id) ? 'visible' : 'none';
      if (map.getLayer(`havza-fill-${hb.id}`)) map.setLayoutProperty(`havza-fill-${hb.id}`, 'visibility', vis);
      if (map.getLayer(`havza-line-${hb.id}`)) map.setLayoutProperty(`havza-line-${hb.id}`, 'visibility', vis);
    });
  }, [mapVisibleHavzalar]);

  useEffect(() => {
    const map = mapRef.current;
    if (!map || !map.isStyleLoaded()) return;
    const showBolge = mapLayer === 'bolge' || mapVisibleBolgeler.length > 0;
    if (map.getLayer('bolge-fill')) map.setLayoutProperty('bolge-fill', 'visibility', showBolge ? 'visible' : 'none');
    if (map.getLayer('bolge-line')) map.setLayoutProperty('bolge-line', 'visibility', showBolge ? 'visible' : 'none');
    if (showBolge && mapVisibleBolgeler.length > 0) {
      const filter = ['in', ['get', 'id'], ['literal', mapVisibleBolgeler]];
      map.setFilter('bolge-fill', filter);
      map.setFilter('bolge-line', filter);
    } else if (showBolge) {
      map.setFilter('bolge-fill', null);
      map.setFilter('bolge-line', null);
    }
  }, [mapVisibleBolgeler, mapLayer]);

  useEffect(() => {
    const map = mapRef.current;
    if (!map || !map.isStyleLoaded() || !map.getSource('parks')) return;
    if (mapShowParks) {
      const allBolgeler = mapVisibleBolgeler.length > 0 ? mapVisibleBolgeler : Object.keys(BOLGE_COORDS).map(Number);
      const features = [];
      allBolgeler.forEach(bId => {
        const bc = BOLGE_COORDS[bId];
        if (!bc) return;
        const parks = getParksForBolge(bId);
        parks.forEach((p, i) => {
          const lng = bc.center[0] + (Math.random() - 0.5) * 0.015;
          const lat = bc.center[1] + (Math.random() - 0.5) * 0.012;
          features.push({ type: 'Feature', properties: { name: p.name, alan: p.alan, suTuketimi: p.suTuketimi, verimlilik: p.verimlilik }, geometry: { type: 'Point', coordinates: [lng, lat] } });
        });
      });
      map.getSource('parks').setData({ type: 'FeatureCollection', features });
      map.setLayoutProperty('park-circles', 'visibility', 'visible');
    } else {
      map.setLayoutProperty('park-circles', 'visibility', 'none');
    }
  }, [mapShowParks, mapVisibleBolgeler]);

  if (showLegacy) {
    return (
      <div>
        <div style={{padding:'12px 32px',background:'#fff7ed',borderBottom:'1px solid #fed7aa',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <span style={{fontSize:13,color:'#92400e',fontWeight:500}}>Eski Dashboard görüntüleniyor</span>
          <button onClick={()=>setShowLegacy(false)} style={{padding:'6px 14px',background:'#3b82f6',color:'white',border:'none',borderRadius:6,cursor:'pointer',fontSize:12,fontWeight:500}}>Yeni Dashboard'a Dön</button>
        </div>
        <LegacyAskiDashboard />
      </div>
    );
  }

  const havzaDisabled = false;
  const ilceDisabled = selectedHavza !== '';
  const bolgeDisabled = selectedHavza !== '' || selectedIlce === '';

  const availableIlceler = selectedHavza
    ? ILCELER.filter(i => HAVZALAR.find(h=>h.id===parseInt(selectedHavza))?.coverage.some(c=>c.ilceId===i.id))
    : ILCELER;

  const currentIlce = ILCELER.find(i => i.id === parseInt(selectedIlce));
  const availableBolgeler = currentIlce ? currentIlce.bolgeler : [];
  const currentBolge = availableBolgeler.find(b => b.id === parseInt(selectedBolge));

  const resetFilters = () => { setSelectedHavza(''); setSelectedIlce(''); setSelectedBolge(''); };

  const getDisplayData = () => {
    if (selectedBolge && currentBolge) {
      const parks = getParksForBolge(currentBolge.id);
      return { level: 'park', title: `${currentBolge.name} Parkları`, items: parks };
    }
    if (selectedIlce && currentIlce) {
      return { level: 'bolge', title: `${currentIlce.name} Bölgeleri`, items: currentIlce.bolgeler };
    }
    if (selectedHavza) {
      const h = HAVZALAR.find(h=>h.id===parseInt(selectedHavza));
      const ilces = ILCELER.filter(i=>h?.coverage.some(c=>c.ilceId===i.id));
      return { level: 'ilce', title: `${h?.name} İlçeleri`, items: ilces };
    }
    return { level: 'ilce', title: 'Ankara İlçeleri', items: ILCELER };
  };

  const displayData = getDisplayData();

  const getIlceSummary = (ilce) => {
    const totalParks = ilce.bolgeler.reduce((s,b) => s + b.parkSayisi, 0);
    const totalArea = ilce.bolgeler.reduce((s,b) => s + b.parkAlani, 0);
    const totalGreen = ilce.bolgeler.reduce((s,b) => s + b.yesilAlan, 0);
    const totalWater = ilce.bolgeler.reduce((s,b) => s + b.suTuketimi, 0);
    return { totalParks, totalArea, totalGreen, totalWater };
  };

  const getTotalStats = () => {
    const scope = displayData.level === 'ilce' ? displayData.items : [];
    if (displayData.level === 'ilce') {
      const tp = scope.reduce((s,i) => s + i.bolgeler.reduce((s2,b)=>s2+b.parkSayisi,0), 0);
      const ta = scope.reduce((s,i) => s + i.bolgeler.reduce((s2,b)=>s2+b.parkAlani,0), 0);
      const tg = scope.reduce((s,i) => s + i.bolgeler.reduce((s2,b)=>s2+b.yesilAlan,0), 0);
      const tw = scope.reduce((s,i) => s + i.bolgeler.reduce((s2,b)=>s2+b.suTuketimi,0), 0);
      const tn = scope.reduce((s,i) => s + i.nufus, 0);
      return { parkSayisi:tp, parkAlani:ta, yesilAlan:tg, suTuketimi:tw, nufus:tn };
    }
    if (displayData.level === 'bolge') {
      const tp = displayData.items.reduce((s,b)=>s+b.parkSayisi,0);
      const ta = displayData.items.reduce((s,b)=>s+b.parkAlani,0);
      const tg = displayData.items.reduce((s,b)=>s+b.yesilAlan,0);
      const tw = displayData.items.reduce((s,b)=>s+b.suTuketimi,0);
      return { parkSayisi:tp, parkAlani:ta, yesilAlan:tg, suTuketimi:tw, nufus:currentIlce?.nufus||0 };
    }
    if (displayData.level === 'park') {
      const parks = displayData.items;
      const tp = parks.length;
      const ta = parks.reduce((s,p)=>s+p.alan,0);
      const tg = parks.reduce((s,p)=>s+p.cimAlani,0);
      const tw = parks.reduce((s,p)=>s+p.suTuketimi,0);
      return { parkSayisi:tp, parkAlani:ta, yesilAlan:tg, suTuketimi:tw, nufus:0 };
    }
    return { parkSayisi:0, parkAlani:0, yesilAlan:0, suTuketimi:0, nufus:0 };
  };

  const stats = getTotalStats();
  const theoreticalCons = stats.suTuketimi * 0.82;
  const waterLoss = stats.suTuketimi - theoreticalCons;
  const lossPercent = stats.suTuketimi > 0 ? ((waterLoss / stats.suTuketimi) * 100).toFixed(1) : 0;
  const efficiencyPercent = stats.suTuketimi > 0 && stats.yesilAlan > 0
    ? (((stats.yesilAlan * 2.5) / stats.suTuketimi) * 100).toFixed(1) : 0;

  const getChartData = () => {
    const addRatios = (item) => ({
      ...item,
      m3PerGreen: item.yesilAlan > 0 ? parseFloat((item.suTuketimi / item.yesilAlan).toFixed(2)) : 0,
      m3PerArea: item.parkAlani > 0 ? parseFloat((item.suTuketimi / item.parkAlani).toFixed(2)) : 0,
      m3PerPark: item.parkSayisi > 0 ? Math.round(item.suTuketimi / item.parkSayisi) : 0,
      greenRatio: item.parkAlani > 0 ? parseFloat(((item.yesilAlan / item.parkAlani) * 100).toFixed(1)) : 0,
    });
    if (displayData.level === 'ilce') {
      return displayData.items.map(i => {
        const s = getIlceSummary(i);
        return addRatios({ name: i.name, suTuketimi: s.totalWater, parkAlani: s.totalArea, yesilAlan: s.totalGreen, parkSayisi: s.totalParks, teorik: Math.round(s.totalWater * 0.82) });
      });
    }
    if (displayData.level === 'bolge') {
      return displayData.items.map(b => addRatios({
        name: b.name, suTuketimi: b.suTuketimi, parkAlani: b.parkAlani, yesilAlan: b.yesilAlan, parkSayisi: b.parkSayisi, teorik: Math.round(b.suTuketimi * 0.82),
      }));
    }
    if (displayData.level === 'park') {
      return displayData.items.slice(0,30).map(p => addRatios({
        name: p.name.replace(/Park-/, 'P'), suTuketimi: p.suTuketimi, parkAlani: p.alan, yesilAlan: p.cimAlani, parkSayisi: 1, teorik: Math.round(p.suTuketimi * 0.82),
      }));
    }
    return [];
  };

  const ANALYSIS_METRICS = [
    { id: 'water_vs_green', label: 'Su Tüketimi / Yeşil Alan', desc: 'Yeşil alan başına su tüketimi (m³/m²)', bars: [{key:'m3PerGreen',name:'m³/m² (Yeşil Alan)',color:'#3b82f6'}] },
    { id: 'water_vs_area', label: 'Su Tüketimi / Toplam Alan', desc: 'Toplam park alanı başına su tüketimi', bars: [{key:'m3PerArea',name:'m³/m² (Toplam Alan)',color:'#8b5cf6'}] },
    { id: 'water_vs_park', label: 'Su Tüketimi / Park', desc: 'Park başına ortalama su tüketimi', bars: [{key:'m3PerPark',name:'m³/park',color:'#f59e0b'}] },
    { id: 'green_ratio', label: 'Yeşil Alan Oranı', desc: 'Park alanının yeşil alana oranı (%)', bars: [{key:'greenRatio',name:'Yeşil Alan Oranı (%)',color:'#10b981'}] },
    { id: 'water_total', label: 'Toplam Su Tüketimi', desc: 'Gerçek ve teorik tüketim karşılaştırması', bars: [{key:'suTuketimi',name:'Gerçek (m³)',color:'#3b82f6'},{key:'teorik',name:'Teorik (m³)',color:'#10b981'}] },
    { id: 'all_compare', label: 'Çoklu Karşılaştırma', desc: 'Su tüketimi, yeşil alan ve park alanı birlikte', bars: [{key:'suTuketimi',name:'Su Tüketimi (m³)',color:'#3b82f6'},{key:'yesilAlan',name:'Yeşil Alan (m²)',color:'#10b981'},{key:'parkAlani',name:'Park Alanı (m²)',color:'#f59e0b'}] },
  ];

  const renderTable = () => {
    if (displayData.level === 'ilce') {
      return (
        <div className={styles.tableSection}>
          <div className={styles.tableSectionHeader}>
            <div><h3 className={styles.tableSectionTitle}>{displayData.title}</h3><p className={styles.tableSectionSubtitle}>Her ilçenin su tüketimini ayrı ayrı görüntüleyin</p></div>
            <span className={styles.tableSectionBadge}>{displayData.items.length} ilçe</span>
          </div>
          <table className={styles.dataTable}>
            <thead><tr><th>İlçe</th><th>Nüfus</th><th>Park Sayısı</th><th>Park Alanı (m²)</th><th>Yeşil Alan (m²)</th><th>Su Tüketimi (m³)</th><th>m³/park</th><th>m³/m²</th></tr></thead>
            <tbody>{displayData.items.map(ilce => {
              const s = getIlceSummary(ilce);
              return (
                <tr key={ilce.id} className={styles.clickableRow} onClick={()=>{setSelectedIlce(String(ilce.id));setSelectedBolge('');}}>
                  <td>{ilce.name} <ChevronRight size={12} style={{opacity:0.4}} /></td>
                  <td className={styles.numberCell}>{ilce.nufus.toLocaleString('tr-TR')}</td>
                  <td className={styles.numberCell}>{s.totalParks}</td>
                  <td className={styles.numberCell}>{s.totalArea.toLocaleString('tr-TR')}</td>
                  <td className={styles.numberCell}>{s.totalGreen.toLocaleString('tr-TR')}</td>
                  <td className={styles.numberCell}>{s.totalWater.toLocaleString('tr-TR')}</td>
                  <td className={styles.numberCell}>{s.totalParks > 0 ? Math.round(s.totalWater/s.totalParks).toLocaleString('tr-TR') : '-'}</td>
                  <td className={styles.numberCell}>{s.totalGreen > 0 ? (s.totalWater/s.totalGreen).toFixed(2) : '-'}</td>
                </tr>);
            })}</tbody>
          </table>
        </div>
      );
    }
    if (displayData.level === 'bolge') {
      return (
        <div className={styles.tableSection}>
          <div className={styles.tableSectionHeader}>
            <div><h3 className={styles.tableSectionTitle}>{displayData.title}</h3><p className={styles.tableSectionSubtitle}>Bölge bazlı su tüketimi detayları</p></div>
            <span className={styles.tableSectionBadge}>{displayData.items.length} bölge</span>
          </div>
          <table className={styles.dataTable}>
            <thead><tr><th>Bölge</th><th>Park Sayısı</th><th>Park Alanı (m²)</th><th>Yeşil Alan (m²)</th><th>Su Tüketimi (m³)</th><th>m³/park</th><th>m³/m²</th></tr></thead>
            <tbody>{displayData.items.map(b => (
              <tr key={b.id} className={styles.clickableRow} onClick={()=>setSelectedBolge(String(b.id))}>
                <td>{b.name} <ChevronRight size={12} style={{opacity:0.4}} /></td>
                <td className={styles.numberCell}>{b.parkSayisi}</td>
                <td className={styles.numberCell}>{b.parkAlani.toLocaleString('tr-TR')}</td>
                <td className={styles.numberCell}>{b.yesilAlan.toLocaleString('tr-TR')}</td>
                <td className={styles.numberCell}>{b.suTuketimi.toLocaleString('tr-TR')}</td>
                <td className={styles.numberCell}>{Math.round(b.suTuketimi/b.parkSayisi).toLocaleString('tr-TR')}</td>
                <td className={styles.numberCell}>{(b.suTuketimi/b.yesilAlan).toFixed(2)}</td>
              </tr>))}</tbody>
          </table>
        </div>
      );
    }
    if (displayData.level === 'park') {
      return (
        <div className={styles.tableSection}>
          <div className={styles.tableSectionHeader}>
            <div><h3 className={styles.tableSectionTitle}>{displayData.title}</h3><p className={styles.tableSectionSubtitle}>{currentBolge?.name} bölgesindeki parklar</p></div>
            <span className={styles.tableSectionBadge}>{displayData.items.length} park</span>
          </div>
          <table className={styles.dataTable}>
            <thead><tr><th>Park</th><th>Alan (m²)</th><th>Çim (m²)</th><th>Su Tüketimi (m³)</th><th>Sayaç</th><th>Sulama</th><th>Verimlilik</th></tr></thead>
            <tbody>{displayData.items.map(p => (
              <tr key={p.id}>
                <td className={styles.parkNameCell}>{p.name} (Alan: {p.alan.toLocaleString('tr-TR')} m² - Çim: {p.cimAlani.toLocaleString('tr-TR')} m²)</td>
                <td className={styles.numberCell}>{p.alan.toLocaleString('tr-TR')}</td>
                <td className={styles.numberCell}>{p.cimAlani.toLocaleString('tr-TR')}</td>
                <td className={styles.numberCell}>{p.suTuketimi.toLocaleString('tr-TR')}</td>
                <td><span className={p.sayacTipi==='GPRS' ? styles.meterGPRS : styles.meterMekanik} style={{padding:'2px 6px',borderRadius:4,fontSize:11}}>{p.sayacTipi}</span></td>
                <td style={{fontSize:11}}>{p.sulamaTipi}</td>
                <td><div className={styles.efficiencyCell}><div className={styles.efficiencyBar}><div className={styles.efficiencyFill} style={{width:`${Math.min(100,p.verimlilik)}%`,backgroundColor:p.verimlilik>=85?'#10b981':p.verimlilik>=70?'#f59e0b':'#ef4444'}} /></div><span className={styles.efficiencyText} style={{color:p.verimlilik>=85?'#10b981':p.verimlilik>=70?'#f59e0b':'#ef4444'}}>{p.verimlilik}%</span></div></td>
              </tr>))}</tbody>
          </table>
        </div>
      );
    }
    return null;
  };

  const renderChart = () => {
    const data = getChartData();
    if (data.length === 0) return null;
    const currentMetric = ANALYSIS_METRICS.find(m => m.id === analysisMetric) || ANALYSIS_METRICS[0];

    const sortedByMetric = currentMetric.bars.length === 1
      ? [...data].sort((a,b) => (b[currentMetric.bars[0].key] || 0) - (a[currentMetric.bars[0].key] || 0))
      : data;

    const topItem = sortedByMetric[0];
    const bottomItem = sortedByMetric[sortedByMetric.length - 1];
    const avgVal = currentMetric.bars.length === 1 && data.length > 0
      ? (data.reduce((s,d) => s + (d[currentMetric.bars[0].key] || 0), 0) / data.length).toFixed(2)
      : null;

    return (
      <div className={styles.chartSection}>
        <div className={styles.chartHeader}>
          <div>
            <h3 className={styles.chartTitle}>Analiz - {displayData.title}</h3>
            <p style={{fontSize:11,color:'#94a3b8',margin:'2px 0 0'}}>{currentMetric.desc}</p>
          </div>
          <div className={styles.chartControls}>
            {['bar','line'].map(t=>(
              <button key={t} className={`${styles.chartTypeBtn} ${chartType===t?styles.chartTypeBtnActive:''}`} onClick={()=>setChartType(t)}>
                {t==='bar'?'Bar':'Çizgi'}
              </button>
            ))}
          </div>
        </div>

        <div className={styles.analysisMetricRow}>
          {ANALYSIS_METRICS.map(m => (
            <button key={m.id} className={`${styles.analysisMetricBtn} ${analysisMetric===m.id?styles.analysisMetricBtnActive:''}`}
              onClick={()=>setAnalysisMetric(m.id)}>
              {m.label}
            </button>
          ))}
        </div>

        {avgVal && (
          <div className={styles.analysisStatsRow}>
            <div className={styles.analysisStat}>
              <span>En Yüksek</span>
              <strong style={{color:'#ef4444'}}>{topItem?.name}: {topItem?.[currentMetric.bars[0].key]?.toLocaleString('tr-TR')}</strong>
            </div>
            <div className={styles.analysisStat}>
              <span>Ortalama</span>
              <strong style={{color:'#3b82f6'}}>{parseFloat(avgVal).toLocaleString('tr-TR')}</strong>
            </div>
            <div className={styles.analysisStat}>
              <span>En Düşük</span>
              <strong style={{color:'#10b981'}}>{bottomItem?.name}: {bottomItem?.[currentMetric.bars[0].key]?.toLocaleString('tr-TR')}</strong>
            </div>
          </div>
        )}

        <ResponsiveContainer width="100%" height={350}>
          {chartType === 'line' ? (
            <LineChart data={sortedByMetric}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" angle={-35} textAnchor="end" height={80} interval={0} tick={{fontSize:10}} />
              <YAxis tick={{fontSize:11}} />
              <Tooltip formatter={(v)=>typeof v==='number'?v.toLocaleString('tr-TR'):v} />
              <Legend />
              {currentMetric.bars.map(b => (
                <Line key={b.key} type="monotone" dataKey={b.key} stroke={b.color} strokeWidth={2} name={b.name} dot={{r:3}} />
              ))}
            </LineChart>
          ) : (
            <BarChart data={sortedByMetric}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" angle={-35} textAnchor="end" height={80} interval={0} tick={{fontSize:10}} />
              <YAxis tick={{fontSize:11}} />
              <Tooltip formatter={(v)=>typeof v==='number'?v.toLocaleString('tr-TR'):v} />
              <Legend />
              {currentMetric.bars.map(b => (
                <Bar key={b.key} dataKey={b.key} fill={b.color} name={b.name} radius={[4,4,0,0]} />
              ))}
            </BarChart>
          )}
        </ResponsiveContainer>
      </div>
    );
  };

  const renderWaterLoss = () => (
    <div className={styles.waterLossSection}>
      <div className={styles.waterLossHeader}>
        <div className={styles.waterLossIcon}><AlertTriangle size={18} /></div>
        <h3>Su Verimlilik Kaybı / Su Kayıp Hesabı</h3>
      </div>
      <div className={styles.waterLossGrid}>
        <div className={styles.waterLossCard}>
          <div className={styles.waterLossCardLabel}>Toplam Su Tüketimi</div>
          <div className={styles.waterLossCardValue}>{stats.suTuketimi.toLocaleString('tr-TR')}<span className={styles.waterLossCardUnit}>m³</span></div>
        </div>
        <div className={styles.waterLossCard}>
          <div className={styles.waterLossCardLabel}>Teorik (Beklenen) Tüketim</div>
          <div className={styles.waterLossCardValue}>{Math.round(theoreticalCons).toLocaleString('tr-TR')}<span className={styles.waterLossCardUnit}>m³</span></div>
        </div>
        <div className={`${styles.waterLossCard} ${styles.waterLossCardDanger}`}>
          <div className={styles.waterLossCardLabel}>Su Kaybı (Fark)</div>
          <div className={styles.waterLossCardValue}>{Math.round(waterLoss).toLocaleString('tr-TR')}<span className={styles.waterLossCardUnit}>m³ (%{lossPercent})</span></div>
        </div>
        <div className={styles.waterLossCard}>
          <div className={styles.waterLossCardLabel}>Verimlilik Oranı</div>
          <div className={styles.waterLossCardValue}>{efficiencyPercent}<span className={styles.waterLossCardUnit}>%</span></div>
        </div>
      </div>
      <div className={styles.waterLossSummary}>
        <strong>Su Kayıp Hesabı Özeti:</strong> Seçili alandaki toplam su tüketimi <strong>{stats.suTuketimi.toLocaleString('tr-TR')} m³</strong> olup, teorik (yeşil alan m² başına ideal tüketim) hesaba göre beklenen tüketim <strong>{Math.round(theoreticalCons).toLocaleString('tr-TR')} m³</strong> seviyesindedir. Aradaki <strong>{Math.round(waterLoss).toLocaleString('tr-TR')} m³</strong> fark (%{lossPercent}), altyapı kayıpları (patlak, sızıntı), aşırı sulama, mekanik sayaç hataları veya buharlaşma gibi nedenlerden kaynaklanabilir.
      </div>
      <div className={styles.waterLossExplanation}>
        <strong>Hesaplama Yöntemi:</strong><br/>
        • Teorik Tüketim = Yeşil Alan (m²) × İdeal Su İhtiyacı (2.5 m³/m²/yıl) × Mevsimsel Katsayı<br/>
        • Su Kaybı = Gerçek Tüketim − Teorik Tüketim<br/>
        • Kayıp Oranı (%) = (Su Kaybı / Gerçek Tüketim) × 100<br/>
        • Verimlilik = (Teorik Tüketim / Gerçek Tüketim) × 100<br/>
        • Kayıp kaynakları: Altyapı sızıntıları, sayaç hataları, buharlaşma, aşırı sulama
      </div>
    </div>
  );

  // --- PDF RAPOR OLUŞTURMA ---
  const tr = (s) => {
    if (!s) return '';
    return String(s)
      .replace(/ç/g,'c').replace(/Ç/g,'C')
      .replace(/ğ/g,'g').replace(/Ğ/g,'G')
      .replace(/ı/g,'i').replace(/İ/g,'I')
      .replace(/ö/g,'o').replace(/Ö/g,'O')
      .replace(/ş/g,'s').replace(/Ş/g,'S')
      .replace(/ü/g,'u').replace(/Ü/g,'U');
  };

  const generatePdfReport = async () => {
    setPdfGenerating(true);
    try {
      const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const W = 210, H = 297;
      const now = new Date();
      const dateStr = now.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
      const monthStr = tr(now.toLocaleDateString('tr-TR', { month: 'long', year: 'numeric' }));
      const scopeTitle = tr(displayData.title);

      const blue = [0, 75, 145];
      const darkBlue = [0, 50, 100];
      const lightBlue = [220, 235, 250];
      const gray = [100, 116, 139];
      const dark = [30, 41, 59];
      const white = [255, 255, 255];
      const red = [220, 38, 38];

      const drawWaterWave = (doc, y, height, opacity) => {
        doc.setFillColor(200, 225, 250);
        doc.setGState(new doc.GState({ opacity }));
        const steps = 40;
        const stepW = W / steps;
        for (let i = 0; i <= steps; i++) {
          const x = i * stepW;
          const waveY = y + Math.sin(i * 0.4) * 4 + Math.cos(i * 0.2) * 3;
          doc.rect(x, waveY, stepW + 0.5, height, 'F');
        }
        doc.setGState(new doc.GState({ opacity: 1 }));
      };

      // Logo'yu yükle
      const logoImg = new Image();
      logoImg.crossOrigin = 'anonymous';
      const logoLoaded = await new Promise((resolve) => {
        logoImg.onload = () => resolve(true);
        logoImg.onerror = () => resolve(false);
        logoImg.src = `${window.location.origin}/logo.png`;
      });

      // ===== KAPAK SAYFASI =====
      doc.setFillColor(245, 249, 255);
      doc.rect(0, 0, W, H, 'F');

      drawWaterWave(doc, 30, 60, 0.15);
      drawWaterWave(doc, 180, 80, 0.12);
      drawWaterWave(doc, 230, 67, 0.08);

      // Üst sol logo
      if (logoLoaded) {
        doc.addImage(logoImg, 'PNG', 15, 12, 50, 25);
      }

      // Merkez ana başlık kutusu
      doc.setFillColor(...white);
      doc.setGState(new doc.GState({ opacity: 0.95 }));
      doc.roundedRect(25, 90, 160, 95, 8, 8, 'F');
      doc.setGState(new doc.GState({ opacity: 1 }));

      // Merkez logo
      if (logoLoaded) {
        doc.addImage(logoImg, 'PNG', 75, 95, 60, 30);
      }

      doc.setFontSize(22);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(...darkBlue);
      doc.text('SU TUKETIMI', 105, 140, { align: 'center' });
      doc.text('ANALIZ RAPORU', 105, 151, { align: 'center' });

      doc.setFont('helvetica', 'italic');
      doc.setFontSize(12);
      doc.setTextColor(...gray);
      doc.text(scopeTitle, 105, 165, { align: 'center' });

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.text(`Donem: ${monthStr}`, 105, 175, { align: 'center' });

      // (kapak footer'ı döngüde çizilecek)

      // ===== SAYFA 2: GENEL TUKETIM OZETI =====
      doc.addPage();

      // Header bar
      doc.setFillColor(245, 249, 255);
      doc.rect(0, 0, W, 20, 'F');
      doc.setDrawColor(200, 215, 235);
      doc.setLineWidth(0.3);
      doc.line(0, 20, W, 20);

      // Sol logo (gerçek)
      if (logoLoaded) {
        doc.addImage(logoImg, 'PNG', 8, 2, 32, 16);
      }

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7);
      doc.setTextColor(...gray);
      doc.text(`Su Tuketimi Analiz Raporu - ${scopeTitle}`, 44, 11);

      // Mavi bant - sayfa başlığı
      doc.setFillColor(...blue);
      doc.rect(0, 24, W, 14, 'F');
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(14);
      doc.setTextColor(...white);
      doc.text('1. GENEL TUKETIM OZETI', 15, 33);

      let y = 48;

      // Özet kartlar
      const summaryCards = [
        { label: 'Toplam Su Tuketimi', value: `${stats.suTuketimi.toLocaleString('tr-TR')} m3`, color: blue },
        { label: 'Kayip-Kacak Orani', value: `%${lossPercent}`, color: red },
        { label: 'Park Sayisi', value: `${stats.parkSayisi.toLocaleString('tr-TR')}`, color: [16, 185, 129] },
        { label: 'Verimlilik Orani', value: `%${efficiencyPercent}`, color: [245, 158, 11] },
      ];

      const cardW = 42;
      const cardGap = 4;
      const startX = 15;

      summaryCards.forEach((card, i) => {
        const cx = startX + i * (cardW + cardGap);
        doc.setFillColor(250, 252, 255);
        doc.setDrawColor(220, 230, 245);
        doc.setLineWidth(0.3);
        doc.roundedRect(cx, y, cardW, 28, 3, 3, 'FD');

        doc.setFillColor(...card.color);
        doc.circle(cx + 8, y + 10, 4.5, 'F');
        doc.setFillColor(...white);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(6);
        doc.setTextColor(...white);
        doc.text(card.label.charAt(0), cx + 8, y + 11.5, { align: 'center' });

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(6.5);
        doc.setTextColor(...gray);
        doc.text(card.label, cx + 15, y + 9);

        doc.setFont('helvetica', 'bold');
        doc.setFontSize(11);
        doc.setTextColor(...card.color);
        doc.text(card.value, cx + 15, y + 19);
      });

      y += 38;

      // Veri tablosu
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(11);
      doc.setTextColor(...darkBlue);
      doc.text(`${scopeTitle} - Detay Tablosu`, 15, y);
      y += 6;

      // Tablo
      const chartData = getChartData();
      if (chartData.length > 0) {
        const colWidths = [42, 32, 32, 32, 32];
        const headers = ['Birim', 'Su Tuketimi (m3)', 'Teorik (m3)', 'Park Alani (m2)', 'Yesil Alan (m2)'];
        const tableX = 15;

        // Tablo başlık
        doc.setFillColor(...blue);
        doc.rect(tableX, y, colWidths.reduce((a, b) => a + b, 0), 8, 'F');
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(7);
        doc.setTextColor(...white);
        let hx = tableX;
        headers.forEach((h, i) => {
          doc.text(h, hx + 2, y + 5.5);
          hx += colWidths[i];
        });
        y += 8;

        const rowData = chartData.slice(0, 20);
        rowData.forEach((row, idx) => {
          if (idx % 2 === 0) {
            doc.setFillColor(248, 250, 252);
            doc.rect(tableX, y, colWidths.reduce((a, b) => a + b, 0), 7, 'F');
          }
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(7);
          doc.setTextColor(...dark);
          let rx = tableX;
          const values = [
            tr(row.name),
            (row.suTuketimi || 0).toLocaleString('tr-TR'),
            (row.teorik || 0).toLocaleString('tr-TR'),
            (row.parkAlani || 0).toLocaleString('tr-TR'),
            (row.yesilAlan || 0).toLocaleString('tr-TR'),
          ];
          values.forEach((v, i) => {
            doc.text(tr(String(v)), rx + 2, y + 5);
            rx += colWidths[i];
          });
          y += 7;

          if (y > H - 50) {
            doc.addPage();
            y = 25;
          }
        });
      }

      y += 8;
      if (y > H - 90) { doc.addPage(); y = 25; }

      // Su Kayıp analizi
      doc.setFillColor(254, 242, 242);
      doc.setDrawColor(254, 202, 202);
      doc.setLineWidth(0.3);
      doc.roundedRect(15, y, W - 30, 55, 4, 4, 'FD');

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(11);
      doc.setTextColor(...red);
      doc.text('Su Verimlilik Kaybi / Su Kayip Hesabi', 20, y + 9);

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      doc.setTextColor(...dark);
      const lossItems = [
        `Toplam Su Tuketimi: ${stats.suTuketimi.toLocaleString('tr-TR')} m3`,
        `Teorik (Beklenen) Tuketim: ${Math.round(theoreticalCons).toLocaleString('tr-TR')} m3`,
        `Su Kaybi (Fark): ${Math.round(waterLoss).toLocaleString('tr-TR')} m3 (%${lossPercent})`,
        `Verimlilik Orani: %${efficiencyPercent}`,
      ];
      lossItems.forEach((item, i) => {
        doc.text(`• ${item}`, 22, y + 18 + i * 7);
      });

      doc.setFont('helvetica', 'italic');
      doc.setFontSize(7);
      doc.setTextColor(...gray);
      doc.text('Kayip kaynaklari: Altyapi sizintilari, sayac hatalari, buhaslasma, asiri sulama', 22, y + 49);

      y += 65;
      if (y > H - 60) { doc.addPage(); y = 25; }

      // Bulgular ve Öneriler
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(11);
      doc.setTextColor(...darkBlue);
      doc.text('Bulgular ve Oneriler', 15, y);
      y += 7;

      const findings = [
        `Secili alandaki toplam park sayisi: ${stats.parkSayisi.toLocaleString('tr-TR')}`,
        `Toplam yesil alan: ${stats.yesilAlan.toLocaleString('tr-TR')} m2`,
        `Toplam su tuketimi: ${stats.suTuketimi.toLocaleString('tr-TR')} m3`,
        `Su kayip orani %${lossPercent} olarak hesaplanmistir.`,
        `Genel verimlilik orani %${efficiencyPercent} seviyesindedir.`,
      ];

      doc.setFillColor(240, 249, 255);
      doc.setDrawColor(186, 230, 253);
      doc.roundedRect(15, y, (W - 30) / 2 - 3, 50, 3, 3, 'FD');

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9);
      doc.setTextColor(...blue);
      doc.text('Bulgular:', 18, y + 8);

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7);
      doc.setTextColor(...dark);
      findings.forEach((f, i) => {
        doc.text(`> ${f}`, 18, y + 15 + i * 6);
      });

      const recX = 15 + (W - 30) / 2 + 3;
      doc.setFillColor(255, 247, 237);
      doc.setDrawColor(254, 215, 170);
      doc.roundedRect(recX, y, (W - 30) / 2 - 3, 50, 3, 3, 'FD');

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9);
      doc.setTextColor(154, 52, 18);
      doc.text('Oneriler:', recX + 3, y + 8);

      const recommendations = [
        'Kayip-kacak oranini azaltmak icin',
        'altyapi yirtasmalarini oncelik verin.',
        'Endustriyel isletmelerde su',
        'verimliligini artiracak onlemler',
        'gelistirin.',
        'GPRS sayac kullanimini yayginlastirin.',
      ];

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7);
      doc.setTextColor(154, 52, 18);
      recommendations.forEach((r, i) => {
        doc.text(`> ${r}`, recX + 3, y + 15 + i * 6);
      });

      y += 58;

      // Footer - tüm sayfalar
      const totalPages = doc.internal.getNumberOfPages();
      for (let p = 1; p <= totalPages; p++) {
        doc.setPage(p);
        const footerY = H - 20;
        doc.setDrawColor(200, 215, 235);
        doc.setLineWidth(0.3);
        doc.line(15, footerY, W - 15, footerY);
        doc.setFillColor(...blue);
        doc.circle(20, footerY + 6, 1.5, 'F');
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7);
        doc.setTextColor(...gray);
        doc.text('www.pronuve.com', 24, footerY + 8);
        doc.text(`Olusturulma Tarihi: ${dateStr}`, 85, footerY + 8);
        doc.text('info@pronuve.com', W - 15, footerY + 8, { align: 'right' });
        if (p > 1) {
          doc.text(`Sayfa ${p - 1} / ${totalPages - 1}`, 105, footerY + 13, { align: 'center' });
        }
      }

      doc.save(`Su_Tuketimi_Raporu_${scopeTitle.replace(/\s+/g, '_')}_${dateStr.replace(/\./g, '')}.pdf`);
    } catch (err) {
      console.error('PDF olusturma hatasi:', err);
      alert('PDF olusturulurken bir hata olustu. Lutfen tekrar deneyin.');
    } finally {
      setPdfGenerating(false);
    }
  };

  // PART3_PLACEHOLDER

  const getAllParksInScope = () => {
    const parks = [];
    const scope = selectedBolge && currentBolge
      ? [currentBolge]
      : selectedIlce && currentIlce
        ? currentIlce.bolgeler
        : availableIlceler.flatMap(i => i.bolgeler);
    scope.forEach(b => { parks.push(...getParksForBolge(b.id)); });
    return parks;
  };

  const getMonthlyData = (parks) => {
    const months = ['Ocak','Subat','Mart','Nisan','Mayis','Haziran','Temmuz','Agustos','Eylul','Ekim','Kasim','Aralik'];
    const coefs = [0.6,0.65,0.8,0.95,1.15,1.3,1.4,1.35,1.1,0.85,0.7,0.55];
    const totalYearly = parks.reduce((s,p) => s+p.suTuketimi, 0);
    return months.map((m,i) => ({ ay: m, tuketim: Math.round(totalYearly * coefs[i] / coefs.reduce((a,b)=>a+b,0)) }));
  };

  const initReportPdf = async (reportTitle) => {
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    const W = 210, H = 297;
    const now = new Date();
    const dateStr = now.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    const scopeLabel = tr(displayData.title);
    const blue = [0,75,145], darkBlue = [0,50,100], gray = [100,116,139], dark = [30,41,59], white = [255,255,255], red = [220,38,38], green = [16,185,129];

    const logoImg = new Image();
    logoImg.crossOrigin = 'anonymous';
    const logoOk = await new Promise(r => { logoImg.onload = () => r(true); logoImg.onerror = () => r(false); logoImg.src = `${window.location.origin}/logo.png`; });

    const drawHeader = (pageTitle) => {
      doc.setFillColor(245,249,255);
      doc.rect(0,0,W,20,'F');
      doc.setDrawColor(200,215,235);
      doc.setLineWidth(0.3);
      doc.line(0,20,W,20);
      if (logoOk) doc.addImage(logoImg, 'PNG', 8, 2, 32, 16);
      doc.setFont('helvetica','normal');
      doc.setFontSize(7);
      doc.setTextColor(...gray);
      doc.text(`${tr(reportTitle)} - ${scopeLabel}`, 44, 11);
      doc.setFillColor(...blue);
      doc.rect(0,24,W,12,'F');
      doc.setFont('helvetica','bold');
      doc.setFontSize(12);
      doc.setTextColor(...white);
      doc.text(tr(reportTitle), 15, 32);
      doc.setFont('helvetica','normal');
      doc.setFontSize(7);
      doc.text(scopeLabel, W-15, 32, { align:'right' });
    };

    const addFooters = () => {
      const tp = doc.internal.getNumberOfPages();
      for (let p = 1; p <= tp; p++) {
        doc.setPage(p);
        const fy = H - 16;
        doc.setDrawColor(200,215,235);
        doc.setLineWidth(0.3);
        doc.line(15, fy, W-15, fy);
        doc.setFillColor(...blue);
        doc.circle(20, fy+5, 1.5, 'F');
        doc.setFont('helvetica','normal');
        doc.setFontSize(7);
        doc.setTextColor(...gray);
        doc.text('www.pronuve.com', 24, fy+7);
        doc.text(`Olusturulma: ${dateStr}`, 85, fy+7);
        doc.text('info@pronuve.com', W-15, fy+7, { align:'right' });
        doc.text(`Sayfa ${p} / ${tp}`, 105, fy+12, { align:'center' });
      }
    };

    const drawTable = (headers, rows, startY, colWidths) => {
      let y = startY;
      const tableW = colWidths.reduce((a,b)=>a+b,0);
      const tX = 15;
      doc.setFillColor(...blue);
      doc.rect(tX, y, tableW, 8, 'F');
      doc.setFont('helvetica','bold');
      doc.setFontSize(7);
      doc.setTextColor(...white);
      let hx = tX;
      headers.forEach((h,i) => { doc.text(h, hx+2, y+5.5); hx += colWidths[i]; });
      y += 8;
      rows.forEach((row, idx) => {
        if (y > H - 30) { doc.addPage(); drawHeader(reportTitle); y = 44; }
        if (idx % 2 === 0) { doc.setFillColor(248,250,252); doc.rect(tX, y, tableW, 7, 'F'); }
        doc.setFont('helvetica','normal');
        doc.setFontSize(7);
        doc.setTextColor(...dark);
        let rx = tX;
        row.forEach((v,i) => { doc.text(tr(String(v)), rx+2, y+5); rx += colWidths[i]; });
        y += 7;
      });
      return y;
    };

    return { doc, W, H, dateStr, scopeLabel, blue, darkBlue, gray, dark, white, red, green, drawHeader, addFooters, drawTable };
  };

  const generateSpecificReport = async (type) => {
    setPdfGenerating(true);
    try {
      const parks = getAllParksInScope();
      const rpt = await initReportPdf(
        type === 'ranking_volume' ? 'Park Siralamasi - Su Hacmi' :
        type === 'ranking_m2' ? 'Park Siralamasi - L/m2' :
        type === 'monthly' ? 'Aylik Su Tuketim Raporu' :
        type === 'summary' ? 'Yillik Ozet Raporu' :
        type === 'analysis' ? 'Teorik vs Gercek Analizi' :
        type === 'havza_compare' ? 'Havza Karsilastirma Raporu' :
        'Su Kaybi Raporu'
      );
      const { doc, W, H, scopeLabel, blue, darkBlue, gray, dark, white, red, green, drawHeader, addFooters, drawTable } = rpt;

      const reportTitle =
        type === 'ranking_volume' ? 'Park Siralamasi - Su Hacmi' :
        type === 'ranking_m2' ? 'Park Siralamasi - L/m2' :
        type === 'monthly' ? 'Aylik Su Tuketim Raporu' :
        type === 'summary' ? 'Yillik Ozet Raporu' :
        type === 'analysis' ? 'Teorik vs Gercek Analizi' :
        type === 'havza_compare' ? 'Havza Karsilastirma Raporu' :
        'Su Kaybi Raporu';

      drawHeader(reportTitle);

      let y = 44;

      // Kapsam bilgisi
      doc.setFillColor(240,249,255);
      doc.setDrawColor(186,230,253);
      doc.roundedRect(15, y, W-30, 14, 3, 3, 'FD');
      doc.setFont('helvetica','normal');
      doc.setFontSize(8);
      doc.setTextColor(...dark);
      doc.text(`Kapsam: ${scopeLabel}  |  Toplam Park: ${parks.length}  |  Toplam Tuketim: ${parks.reduce((s,p)=>s+p.suTuketimi,0).toLocaleString('tr-TR')} m3`, 20, y+9);
      y += 22;

      if (type === 'ranking_volume') {
        const sorted = [...parks].sort((a,b) => b.suTuketimi - a.suTuketimi);
        doc.setFont('helvetica','bold'); doc.setFontSize(10); doc.setTextColor(...darkBlue);
        doc.text('Su Tuketim Hacmine Gore Siralama (Yuksekten Dusuge)', 15, y); y += 7;
        const rows = sorted.slice(0,50).map((p,i) => [
          `${i+1}`, tr(p.name), p.alan.toLocaleString('tr-TR'), p.cimAlani.toLocaleString('tr-TR'),
          p.suTuketimi.toLocaleString('tr-TR'), p.sayacTipi, `%${p.verimlilik}`
        ]);
        y = drawTable(['#','Park Adi','Alan (m2)','Cim (m2)','Su Tuk. (m3)','Sayac','Verim'], rows, y, [10,48,24,24,28,20,18]);

      } else if (type === 'ranking_m2') {
        const sorted = [...parks].map(p => ({...p, lm2: p.cimAlani > 0 ? (p.suTuketimi / p.cimAlani).toFixed(2) : 0})).sort((a,b) => b.lm2 - a.lm2);
        doc.setFont('helvetica','bold'); doc.setFontSize(10); doc.setTextColor(...darkBlue);
        doc.text('Metrekare Basina Tuketim Siralamasi (L/m2)', 15, y); y += 7;
        const rows = sorted.slice(0,50).map((p,i) => [
          `${i+1}`, tr(p.name), p.alan.toLocaleString('tr-TR'), p.cimAlani.toLocaleString('tr-TR'),
          p.suTuketimi.toLocaleString('tr-TR'), String(p.lm2), `%${p.verimlilik}`
        ]);
        y = drawTable(['#','Park Adi','Alan (m2)','Cim (m2)','Su Tuk. (m3)','m3/m2','Verim'], rows, y, [10,48,24,24,28,20,18]);

      } else if (type === 'monthly') {
        const monthly = getMonthlyData(parks);
        doc.setFont('helvetica','bold'); doc.setFontSize(10); doc.setTextColor(...darkBlue);
        doc.text('Aylik Su Tuketim Dagilimi', 15, y); y += 7;
        const rows = monthly.map(m => [m.ay, m.tuketim.toLocaleString('tr-TR')]);
        y = drawTable(['Ay','Su Tuketimi (m3)'], rows, y, [60,60]);
        y += 8;
        const total = monthly.reduce((s,m)=>s+m.tuketim,0);
        doc.setFont('helvetica','bold'); doc.setFontSize(9); doc.setTextColor(...dark);
        doc.text(`Yillik Toplam: ${total.toLocaleString('tr-TR')} m3`, 15, y); y += 5;
        doc.text(`Aylik Ortalama: ${Math.round(total/12).toLocaleString('tr-TR')} m3`, 15, y); y += 5;
        const maxM = monthly.reduce((a,b)=>a.tuketim>b.tuketim?a:b);
        const minM = monthly.reduce((a,b)=>a.tuketim<b.tuketim?a:b);
        doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(...gray);
        y += 3;
        doc.text(`En yuksek tuketim: ${maxM.ay} (${maxM.tuketim.toLocaleString('tr-TR')} m3)`, 15, y); y += 5;
        doc.text(`En dusuk tuketim: ${minM.ay} (${minM.tuketim.toLocaleString('tr-TR')} m3)`, 15, y);

      } else if (type === 'summary') {
        doc.setFont('helvetica','bold'); doc.setFontSize(10); doc.setTextColor(...darkBlue);
        doc.text('Yillik Performans Ozeti', 15, y); y += 10;
        const totalWater = parks.reduce((s,p)=>s+p.suTuketimi,0);
        const totalArea = parks.reduce((s,p)=>s+p.alan,0);
        const totalGreen = parks.reduce((s,p)=>s+p.cimAlani,0);
        const gprsCount = parks.filter(p=>p.sayacTipi==='GPRS').length;
        const autoCount = parks.filter(p=>p.sulamaTipi==='Otomatik').length;
        const avgEff = parks.length > 0 ? Math.round(parks.reduce((s,p)=>s+p.verimlilik,0)/parks.length) : 0;
        const items = [
          ['Toplam Park Sayisi', `${parks.length}`],
          ['Toplam Park Alani', `${totalArea.toLocaleString('tr-TR')} m2`],
          ['Toplam Cim / Yesil Alan', `${totalGreen.toLocaleString('tr-TR')} m2`],
          ['Toplam Su Tuketimi', `${totalWater.toLocaleString('tr-TR')} m3`],
          ['Teorik Tuketim', `${Math.round(totalWater*0.82).toLocaleString('tr-TR')} m3`],
          ['Ortalama Verimlilik', `%${avgEff}`],
          ['GPRS Sayac Orani', `%${parks.length>0?Math.round(gprsCount/parks.length*100):0} (${gprsCount} adet)`],
          ['Otomatik Sulama Orani', `%${parks.length>0?Math.round(autoCount/parks.length*100):0} (${autoCount} adet)`],
          ['m3/park Ortalama', `${parks.length>0?Math.round(totalWater/parks.length).toLocaleString('tr-TR'):0} m3`],
          ['m3/m2 Ortalama', `${totalGreen>0?(totalWater/totalGreen).toFixed(2):'0'}`],
        ];
        items.forEach(([label, val]) => {
          doc.setFillColor(248,250,252); doc.roundedRect(15, y, W-30, 9, 2, 2, 'F');
          doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(...dark);
          doc.text(label, 20, y+6);
          doc.setFont('helvetica','bold'); doc.setTextColor(...blue);
          doc.text(val, W-20, y+6, { align:'right' });
          y += 11;
        });

      } else if (type === 'analysis') {
        doc.setFont('helvetica','bold'); doc.setFontSize(10); doc.setTextColor(...darkBlue);
        doc.text('Teorik vs Gercek Tuketim Karsilastirmasi', 15, y); y += 7;
        const sorted = [...parks].sort((a,b) => b.suTuketimi - a.suTuketimi);
        const rows = sorted.slice(0,50).map((p,i) => {
          const teorik = Math.round(p.cimAlani * 2.5 * (0.7 + Math.random()*0.15));
          const fark = p.suTuketimi - teorik;
          const oran = teorik > 0 ? Math.round((fark/teorik)*100) : 0;
          return [`${i+1}`, tr(p.name), p.suTuketimi.toLocaleString('tr-TR'), teorik.toLocaleString('tr-TR'),
            (fark>0?'+':'')+fark.toLocaleString('tr-TR'), `${oran>0?'+':''}${oran}%`];
        });
        y = drawTable(['#','Park Adi','Gercek (m3)','Teorik (m3)','Fark (m3)','Sapma'], rows, y, [10,48,28,28,28,22]);

      } else if (type === 'loss') {
        doc.setFont('helvetica','bold'); doc.setFontSize(10); doc.setTextColor(...darkBlue);
        doc.text('Detayli Su Kaybi Analizi', 15, y); y += 10;
        const totalWater = parks.reduce((s,p)=>s+p.suTuketimi,0);
        const totalGreen = parks.reduce((s,p)=>s+p.cimAlani,0);
        const teorikTotal = Math.round(totalGreen * 2.5 * 0.82);
        const loss = totalWater - teorikTotal;
        const lossPct = totalWater > 0 ? ((loss/totalWater)*100).toFixed(1) : 0;

        doc.setFillColor(254,242,242); doc.setDrawColor(254,202,202);
        doc.roundedRect(15, y, W-30, 48, 4, 4, 'FD');
        doc.setFont('helvetica','bold'); doc.setFontSize(10); doc.setTextColor(...red);
        doc.text('Su Kayip Ozeti', 20, y+9);
        const lossLines = [
          `Gercek Toplam Tuketim: ${totalWater.toLocaleString('tr-TR')} m3`,
          `Teorik Beklenen Tuketim: ${teorikTotal.toLocaleString('tr-TR')} m3`,
          `Hesaplanan Su Kaybi: ${loss.toLocaleString('tr-TR')} m3`,
          `Kayip Orani: %${lossPct}`,
        ];
        doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(...dark);
        lossLines.forEach((l,i) => { doc.text(`  ${l}`, 22, y+18+i*7); });
        y += 56;

        doc.setFont('helvetica','bold'); doc.setFontSize(9); doc.setTextColor(...darkBlue);
        doc.text('Park Bazinda Kayip Detaylari', 15, y); y += 7;
        const sorted = [...parks].sort((a,b) => {
          const lA = a.suTuketimi - Math.round(a.cimAlani*2.5*0.82);
          const lB = b.suTuketimi - Math.round(b.cimAlani*2.5*0.82);
          return lB - lA;
        });
        const rows = sorted.slice(0,40).map((p,i) => {
          const t = Math.round(p.cimAlani*2.5*0.82);
          const l = p.suTuketimi - t;
          const pct = p.suTuketimi>0?((l/p.suTuketimi)*100).toFixed(1):'0';
          return [`${i+1}`, tr(p.name), p.suTuketimi.toLocaleString('tr-TR'), t.toLocaleString('tr-TR'), l.toLocaleString('tr-TR'), `%${pct}`];
        });
        y = drawTable(['#','Park Adi','Gercek (m3)','Teorik (m3)','Kayip (m3)','Kayip %'], rows, y, [10,48,28,28,28,22]);
      } else if (type === 'havza_compare') {
        doc.setFont('helvetica','bold'); doc.setFontSize(10); doc.setTextColor(...darkBlue);
        doc.text('Havza Karsilastirma Analizi', 15, y); y += 10;

        const hData = compareHavzalar.map(id => { const h = HAVZALAR.find(hh=>hh.id===id); return h ? getHavzaStats(h) : null; }).filter(Boolean);
        if (hData.length < 2) {
          doc.setFont('helvetica','normal'); doc.setFontSize(9); doc.setTextColor(...gray);
          doc.text('Karsilastirma icin en az 2 havza secilmeli.', 15, y);
        } else {
          const metrics = [
            ['Ilce Sayisi', h => String(h.ilceSayisi)],
            ['Ilceler', h => tr(h.ilceAdlari.join(', '))],
            ['Park Sayisi', h => h.parkSayisi.toLocaleString('tr-TR')],
            ['Park Alani (m2)', h => h.parkAlani.toLocaleString('tr-TR')],
            ['Yesil Alan (m2)', h => h.yesilAlan.toLocaleString('tr-TR')],
            ['Su Tuketimi (m3)', h => h.suTuketimi.toLocaleString('tr-TR')],
            ['Teorik Tuketim (m3)', h => h.teorik.toLocaleString('tr-TR')],
            ['Su Kaybi (m3)', h => h.kayip.toLocaleString('tr-TR')],
            ['Kayip Orani', h => `%${h.kayipOran}`],
            ['Verimlilik', h => `%${h.verimlilik}`],
            ['Nufus', h => h.nufus.toLocaleString('tr-TR')],
            ['m3/park', h => h.parkSayisi > 0 ? Math.round(h.suTuketimi/h.parkSayisi).toLocaleString('tr-TR') : '-'],
            ['m3/m2', h => h.yesilAlan > 0 ? (h.suTuketimi/h.yesilAlan).toFixed(2) : '-'],
          ];
          const colW = [45, ...hData.map(() => Math.floor((W-30-45)/hData.length))];
          const headers = ['Metrik', ...hData.map(h => tr(h.name))];
          const rows = metrics.map(([label, fn]) => [label, ...hData.map(fn)]);
          y = drawTable(headers, rows, y, colW);
          y += 10;

          doc.setFont('helvetica','bold'); doc.setFontSize(9); doc.setTextColor(...darkBlue);
          doc.text('Degerlendirme', 15, y); y += 6;
          const best = [...hData].sort((a,b) => parseFloat(b.verimlilik) - parseFloat(a.verimlilik))[0];
          const worst = [...hData].sort((a,b) => parseFloat(a.verimlilik) - parseFloat(b.verimlilik))[0];
          const mostWater = [...hData].sort((a,b) => b.suTuketimi - a.suTuketimi)[0];
          const evalLines = [
            `En verimli havza: ${tr(best.name)} (%${best.verimlilik})`,
            `En dusuk verimlilik: ${tr(worst.name)} (%${worst.verimlilik})`,
            `En yuksek su tuketimi: ${tr(mostWater.name)} (${mostWater.suTuketimi.toLocaleString('tr-TR')} m3)`,
            `Toplam havza sayisi: ${hData.length}`,
          ];
          doc.setFillColor(240,249,255); doc.setDrawColor(186,230,253);
          doc.roundedRect(15, y, W-30, 38, 3, 3, 'FD');
          doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(...dark);
          evalLines.forEach((l,i) => { doc.text(`> ${l}`, 20, y+8+i*7); });
        }
      }

      addFooters();
      const titleMap = { ranking_volume:'Park_Siralama_Hacim', ranking_m2:'Park_Siralama_m2', monthly:'Aylik_Tuketim', summary:'Yillik_Ozet', analysis:'Teorik_Gercek', loss:'Su_Kaybi', havza_compare:'Havza_Karsilastirma' };
      doc.save(`${titleMap[type]}_${scopeLabel.replace(/\s+/g,'_')}.pdf`);
    } catch (err) {
      console.error('Rapor PDF hatasi:', err);
      alert('Rapor olusturulurken bir hata olustu.');
    } finally {
      setPdfGenerating(false);
    }
  };

  const getHavzaStats = (havza) => {
    let parkSayisi = 0, parkAlani = 0, yesilAlan = 0, suTuketimi = 0, nufus = 0;
    const ilceDetails = [];
    havza.coverage.forEach(c => {
      const ilce = ILCELER.find(i => i.id === c.ilceId);
      if (!ilce) return;
      const bolgeler = ilce.bolgeler;
      parkSayisi += Math.round(bolgeler.reduce((s,b) => s + b.parkSayisi, 0) * c.oran);
      parkAlani += Math.round(bolgeler.reduce((s,b) => s + b.parkAlani, 0) * c.oran);
      yesilAlan += Math.round(bolgeler.reduce((s,b) => s + b.yesilAlan, 0) * c.oran);
      suTuketimi += Math.round(bolgeler.reduce((s,b) => s + b.suTuketimi, 0) * c.oran);
      nufus += Math.round(ilce.nufus * c.oran);
      ilceDetails.push({ name: ilce.name, oran: c.oran });
    });
    const teorik = Math.round(suTuketimi * 0.82);
    const kayip = suTuketimi - teorik;
    const kayipOran = suTuketimi > 0 ? ((kayip / suTuketimi) * 100).toFixed(1) : 0;
    const verimlilik = suTuketimi > 0 && yesilAlan > 0 ? (((yesilAlan * 2.5) / suTuketimi) * 100).toFixed(1) : 0;
    return { name: havza.name, ilceSayisi: havza.coverage.length, ilceAdlari: ilceDetails.map(d=>`${d.name} (%${Math.round(d.oran*100)})`), parkSayisi, parkAlani, yesilAlan, suTuketimi, nufus, teorik, kayip, kayipOran, verimlilik };
  };

  const toggleHavzaCompare = (havzaId) => {
    setCompareHavzalar(prev => prev.includes(havzaId) ? prev.filter(id => id !== havzaId) : [...prev, havzaId]);
  };

  const havzaCompareData = compareHavzalar.map(id => {
    const h = HAVZALAR.find(hh => hh.id === id);
    return h ? getHavzaStats(h) : null;
  }).filter(Boolean);

  const havzaChartData = havzaCompareData.map(h => ({
    name: h.name, suTuketimi: h.suTuketimi, teorik: h.teorik, parkSayisi: h.parkSayisi, parkAlani: h.parkAlani, yesilAlan: h.yesilAlan, kayip: h.kayip, nufus: h.nufus,
  }));

  const HAVZA_COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'];

  const renderHavzaCompare = () => (
    <div className={styles.chartSection}>
      <div className={styles.chartHeader}>
        <h3 className={styles.chartTitle}>Havza Karşılaştırması</h3>
        <button className={`${styles.headerBtn} ${styles.pdfBtn}`} onClick={()=>generateSpecificReport('havza_compare')} disabled={pdfGenerating || compareHavzalar.length < 2} style={{fontSize:11,padding:'5px 10px'}}>
          <Download size={13} /> PDF
        </button>
      </div>
      <p style={{fontSize:12,color:'#64748b',margin:'0 0 14px'}}>Karşılaştırmak istediğiniz havzaları seçin (en az 2)</p>
      <div className={styles.havzaToggleRow}>
        {HAVZALAR.map((h,i) => (
          <button key={h.id} className={`${styles.havzaToggleBtn} ${compareHavzalar.includes(h.id) ? styles.havzaToggleBtnActive : ''}`}
            style={compareHavzalar.includes(h.id) ? {borderColor: HAVZA_COLORS[i], background: HAVZA_COLORS[i]+'18', color: HAVZA_COLORS[i]} : {}}
            onClick={() => toggleHavzaCompare(h.id)}>
            {h.name}
            <span style={{fontSize:10,opacity:0.7,marginLeft:4}}>({h.coverage.map(c=>{const il=ILCELER.find(i=>i.id===c.ilceId); return `${il?.name} %${Math.round(c.oran*100)}`;}).join(', ')})</span>
          </button>
        ))}
      </div>

      {compareHavzalar.length >= 2 && (<>
        <div className={styles.havzaCompareGrid}>
          {havzaCompareData.map((h, i) => (
            <div key={h.name} className={styles.havzaCompareCard} style={{borderTopColor: HAVZA_COLORS[i]}}>
              <div className={styles.havzaCompareCardTitle} style={{color: HAVZA_COLORS[i]}}>{h.name}</div>
              <div className={styles.havzaCompareCardIlce}>{h.ilceAdlari.join(', ')}</div>
              <div className={styles.havzaCompareCardStats}>
                <div><span>Park</span><strong>{h.parkSayisi}</strong></div>
                <div><span>Su Tüketimi</span><strong>{h.suTuketimi.toLocaleString('tr-TR')} m³</strong></div>
                <div><span>Yeşil Alan</span><strong>{h.yesilAlan.toLocaleString('tr-TR')} m²</strong></div>
                <div><span>Nüfus</span><strong>{h.nufus.toLocaleString('tr-TR')}</strong></div>
                <div><span>Kayıp Oranı</span><strong style={{color:'#ef4444'}}>%{h.kayipOran}</strong></div>
                <div><span>Verimlilik</span><strong style={{color:'#10b981'}}>%{h.verimlilik}</strong></div>
              </div>
            </div>
          ))}
        </div>

        <div style={{marginTop:20}}>
          <h4 style={{fontSize:13,fontWeight:600,color:'#1e293b',margin:'0 0 12px'}}>Su Tüketimi Karşılaştırması</h4>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={havzaChartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" tick={{fontSize:11}} />
              <YAxis tick={{fontSize:11}} />
              <Tooltip formatter={(v)=>v.toLocaleString('tr-TR')} />
              <Legend />
              <Bar dataKey="suTuketimi" fill="#3b82f6" name="Gerçek Tüketim (m³)" radius={[4,4,0,0]} />
              <Bar dataKey="teorik" fill="#10b981" name="Teorik Tüketim (m³)" radius={[4,4,0,0]} />
              <Bar dataKey="kayip" fill="#ef4444" name="Su Kaybı (m³)" radius={[4,4,0,0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div style={{marginTop:20}}>
          <h4 style={{fontSize:13,fontWeight:600,color:'#1e293b',margin:'0 0 12px'}}>Detay Karşılaştırma Tablosu</h4>
          <table className={styles.dataTable}>
            <thead><tr><th>Metrik</th>{havzaCompareData.map((h,i)=><th key={i} style={{color:HAVZA_COLORS[i]}}>{h.name}</th>)}</tr></thead>
            <tbody>
              {[
                {label:'İlçe Sayısı', key:'ilceSayisi', fmt:v=>v},
                {label:'Park Sayısı', key:'parkSayisi', fmt:v=>v.toLocaleString('tr-TR')},
                {label:'Park Alanı (m²)', key:'parkAlani', fmt:v=>v.toLocaleString('tr-TR')},
                {label:'Yeşil Alan (m²)', key:'yesilAlan', fmt:v=>v.toLocaleString('tr-TR')},
                {label:'Su Tüketimi (m³)', key:'suTuketimi', fmt:v=>v.toLocaleString('tr-TR')},
                {label:'Teorik Tüketim (m³)', key:'teorik', fmt:v=>v.toLocaleString('tr-TR')},
                {label:'Su Kaybı (m³)', key:'kayip', fmt:v=>v.toLocaleString('tr-TR')},
                {label:'Kayıp Oranı', key:'kayipOran', fmt:v=>`%${v}`},
                {label:'Verimlilik', key:'verimlilik', fmt:v=>`%${v}`},
                {label:'Nüfus', key:'nufus', fmt:v=>v.toLocaleString('tr-TR')},
                {label:'m³/park', key:null, fmt:(v,h)=>h.parkSayisi>0?Math.round(h.suTuketimi/h.parkSayisi).toLocaleString('tr-TR'):'-'},
                {label:'m³/m² (yeşil alan)', key:null, fmt:(v,h)=>h.yesilAlan>0?(h.suTuketimi/h.yesilAlan).toFixed(2):'-'},
              ].map(row => (
                <tr key={row.label}>
                  <td style={{fontWeight:500}}>{row.label}</td>
                  {havzaCompareData.map((h,i)=><td key={i} className={styles.numberCell}>{row.key ? row.fmt(h[row.key]) : row.fmt(null,h)}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>)}

      {compareHavzalar.length < 2 && compareHavzalar.length > 0 && (
        <div style={{padding:20,textAlign:'center',color:'#94a3b8',fontSize:13}}>Karşılaştırma için en az 2 havza seçin</div>
      )}
      {compareHavzalar.length === 0 && (
        <div style={{padding:20,textAlign:'center',color:'#94a3b8',fontSize:13}}>Yukarıdaki butonlardan havzaları seçerek karşılaştırma yapabilirsiniz</div>
      )}
    </div>
  );

  const renderReporting = () => {
    const meterStats = displayData.level === 'park' ? {
      gprs: displayData.items.filter(p=>p.sayacTipi==='GPRS').length,
      mekanik: displayData.items.filter(p=>p.sayacTipi==='Mekanik').length,
      otomatik: displayData.items.filter(p=>p.sulamaTipi==='Otomatik').length,
      manuel: displayData.items.filter(p=>p.sulamaTipi==='Manuel').length,
    } : { gprs: Math.round(stats.parkSayisi*0.6), mekanik: Math.round(stats.parkSayisi*0.4), otomatik: Math.round(stats.parkSayisi*0.55), manuel: Math.round(stats.parkSayisi*0.45) };

    return (
      <div className={styles.reportingSection}>
        <div className={styles.reportingHeader}>
          <h3>Raporlama & Sayaç Bilgileri</h3>
          <p>Sayaç tipi (GPRS/Mekanik) ve sulama tipi (Otomatik/Manuel) dağılımı - filtreleme ile elde edilen sonuçlar</p>
        </div>
        <div className={styles.meterGrid}>
          <div className={styles.meterCard}><div className={styles.meterCardType}>GPRS Sayaç</div><div className={styles.meterCardValue}>{meterStats.gprs}</div><div className={styles.meterCardUnit}>adet</div></div>
          <div className={styles.meterCard}><div className={styles.meterCardType}>Mekanik Sayaç</div><div className={styles.meterCardValue}>{meterStats.mekanik}</div><div className={styles.meterCardUnit}>adet</div></div>
          <div className={styles.meterCard}><div className={styles.meterCardType}>Otomatik Sulama</div><div className={styles.meterCardValue}>{meterStats.otomatik}</div><div className={styles.meterCardUnit}>adet</div></div>
          <div className={styles.meterCard}><div className={styles.meterCardType}>Manuel Sulama</div><div className={styles.meterCardValue}>{meterStats.manuel}</div><div className={styles.meterCardUnit}>adet</div></div>
        </div>
        <div className={styles.reportingGrid} style={{marginTop:16}}>
          <div className={styles.reportCard} onClick={()=>generateSpecificReport('ranking_volume')}><div className={styles.reportCardBadge} style={{background:'#3b82f6'}}>RANKING</div><div className={styles.reportCardTitle}>Park Sıralaması - Su Hacmi</div><div className={styles.reportCardDesc}>{pdfGenerating ? 'Hazırlanıyor...' : 'Toplam su tüketimine göre sıralama'}</div></div>
          <div className={styles.reportCard} onClick={()=>generateSpecificReport('ranking_m2')}><div className={styles.reportCardBadge} style={{background:'#10b981'}}>RANKING</div><div className={styles.reportCardTitle}>Park Sıralaması - L/m²</div><div className={styles.reportCardDesc}>{pdfGenerating ? 'Hazırlanıyor...' : 'Metre kare başına tüketim sıralaması'}</div></div>
          <div className={styles.reportCard} onClick={()=>generateSpecificReport('monthly')}><div className={styles.reportCardBadge} style={{background:'#f59e0b'}}>WATER</div><div className={styles.reportCardTitle}>Aylık Su Tüketim Raporu</div><div className={styles.reportCardDesc}>{pdfGenerating ? 'Hazırlanıyor...' : 'Seçili parkların aylık detayları'}</div></div>
          <div className={styles.reportCard} onClick={()=>generateSpecificReport('summary')}><div className={styles.reportCardBadge} style={{background:'#8b5cf6'}}>SUMMARY</div><div className={styles.reportCardTitle}>Yıllık Özet Raporu</div><div className={styles.reportCardDesc}>{pdfGenerating ? 'Hazırlanıyor...' : 'Yıllık toplam performans özeti'}</div></div>
          <div className={styles.reportCard} onClick={()=>generateSpecificReport('analysis')}><div className={styles.reportCardBadge} style={{background:'#ef4444'}}>ANALYSIS</div><div className={styles.reportCardTitle}>Teorik vs Gerçek Analizi</div><div className={styles.reportCardDesc}>{pdfGenerating ? 'Hazırlanıyor...' : 'Tüketim karşılaştırma analizi'}</div></div>
          <div className={styles.reportCard} onClick={()=>generateSpecificReport('loss')}><div className={styles.reportCardBadge} style={{background:'#06b6d4'}}>LOSS</div><div className={styles.reportCardTitle}>Su Kaybı Raporu</div><div className={styles.reportCardDesc}>{pdfGenerating ? 'Hazırlanıyor...' : 'Detaylı su kaybı hesaplamaları'}</div></div>
          <div className={styles.reportCard} onClick={()=>{if(compareHavzalar.length>=2) generateSpecificReport('havza_compare'); else setActiveTab('compare');}}><div className={styles.reportCardBadge} style={{background:'#7c3aed'}}>COMPARE</div><div className={styles.reportCardTitle}>Havza Karşılaştırma</div><div className={styles.reportCardDesc}>{compareHavzalar.length>=2 ? (pdfGenerating ? 'Hazırlanıyor...' : `${compareHavzalar.length} havza seçili - PDF indir`) : 'Havza seçimi yapın'}</div></div>
        </div>
      </div>
    );
  };

  const breadcrumbItems = [];
  breadcrumbItems.push({ label: 'Ankara', onClick: resetFilters });
  if (selectedHavza) { const h = HAVZALAR.find(hh=>hh.id===parseInt(selectedHavza)); breadcrumbItems.push({ label: h?.name||'', onClick: ()=>{setSelectedIlce('');setSelectedBolge('');} }); }
  if (selectedIlce && currentIlce) { breadcrumbItems.push({ label: currentIlce.name, onClick: ()=>setSelectedBolge('') }); }
  if (selectedBolge && currentBolge) { breadcrumbItems.push({ label: currentBolge.name, onClick: null }); }

  return (
    <div className={styles.dashboard}>
      <div className={styles.header}>
        <h1>ASKİ Dashboard</h1>
        <div className={styles.headerRight}>
          <button className={`${styles.headerBtn} ${styles.pdfBtn}`} onClick={generatePdfReport} disabled={pdfGenerating}><Download size={15} />{pdfGenerating ? 'Hazirlaniyor...' : 'PDF Rapor Indir'}</button>
          <button className={`${styles.headerBtn} ${styles.legacyBtn}`} onClick={()=>setShowLegacy(true)}>Eski Dashboard</button>
          <button className={styles.logoutButton} onClick={logout}><LogOut size={15} /> Çıkış</button>
        </div>
      </div>

      <div className={styles.selectionBar}>
        <div className={styles.selectGroup}>
          <label className={styles.selectLabel}>İl</label>
          <select className={styles.selectInput} value={selectedIl} disabled><option>Ankara</option></select>
        </div>
        <div className={styles.selectGroup}>
          <label className={styles.selectLabel}>Havza (Opsiyonel)</label>
          <select className={styles.selectInput} value={selectedHavza} onChange={e=>{setSelectedHavza(e.target.value);setSelectedIlce('');setSelectedBolge('');}}>
            <option value="">Tümü</option>
            {HAVZALAR.map(h=><option key={h.id} value={h.id}>{h.name} ({h.coverage.map(c=>{const il=ILCELER.find(i=>i.id===c.ilceId); return `${il?.name||''} %${Math.round(c.oran*100)}`;}).join(', ')})</option>)}
          </select>
        </div>
        <div className={styles.selectGroup}>
          <label className={styles.selectLabel}>İlçe</label>
          <select className={styles.selectInput} value={selectedIlce} onChange={e=>{setSelectedIlce(e.target.value);setSelectedBolge('');}} disabled={ilceDisabled}>
            <option value="">Tümü</option>
            {availableIlceler.map(i=><option key={i.id} value={i.id}>{i.name}</option>)}
          </select>
        </div>
        <div className={styles.selectGroup}>
          <label className={styles.selectLabel}>Bölge</label>
          <select className={styles.selectInput} value={selectedBolge} onChange={e=>setSelectedBolge(e.target.value)} disabled={bolgeDisabled}>
            <option value="">Tümü</option>
            {availableBolgeler.map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
          </select>
        </div>
        <button className={styles.resetBtn} onClick={resetFilters}>Sıfırla</button>
      </div>

      {(selectedIlce || selectedHavza || selectedBolge) && (
        <div className={styles.breadcrumb}>
          {breadcrumbItems.map((item, idx) => (
            <React.Fragment key={idx}>
              {idx > 0 && <span className={styles.breadcrumbSep}>/</span>}
              {idx < breadcrumbItems.length - 1
                ? <span className={styles.breadcrumbItem} onClick={item.onClick}>{item.label}</span>
                : <span className={styles.breadcrumbCurrent}>{item.label}</span>}
            </React.Fragment>
          ))}
        </div>
      )}

      <div className={styles.summaryRow}>
        <div className={styles.summaryCard}><div className={styles.summaryCardLabel}>Park Sayısı</div><div className={styles.summaryCardValue}>{stats.parkSayisi.toLocaleString('tr-TR')}</div></div>
        <div className={styles.summaryCard}><div className={styles.summaryCardLabel}>Park Alanı</div><div className={styles.summaryCardValue}>{stats.parkAlani.toLocaleString('tr-TR')}<span className={styles.summaryCardUnit}>m²</span></div></div>
        <div className={styles.summaryCard}><div className={styles.summaryCardLabel}>Yeşil Alan</div><div className={styles.summaryCardValue}>{stats.yesilAlan.toLocaleString('tr-TR')}<span className={styles.summaryCardUnit}>m²</span></div></div>
        <div className={styles.summaryCard}><div className={styles.summaryCardLabel}>Su Tüketimi</div><div className={styles.summaryCardValue}>{stats.suTuketimi.toLocaleString('tr-TR')}<span className={styles.summaryCardUnit}>m³</span></div></div>
        {stats.nufus > 0 && <div className={styles.summaryCard}><div className={styles.summaryCardLabel}>Nüfus</div><div className={styles.summaryCardValue}>{stats.nufus.toLocaleString('tr-TR')}</div></div>}
        <div className={styles.summaryCard}><div className={styles.summaryCardLabel}>Verimlilik</div><div className={styles.summaryCardValue}>{efficiencyPercent}<span className={styles.summaryCardUnit}>%</span></div></div>
      </div>

      <div className={styles.navTabs}>
        <button className={`${styles.navTab} ${activeTab==='reports'?styles.navTabActive:''}`} onClick={()=>setActiveTab('reports')}><BarChart3 size={14} /> Raporlar & Analiz</button>
        <button className={`${styles.navTab} ${activeTab==='compare'?styles.navTabActive:''}`} onClick={()=>setActiveTab('compare')}><Layers size={14} /> Havza Karşılaştırma</button>
        <button className={`${styles.navTab} ${activeTab==='table'?styles.navTabActive:''}`} onClick={()=>setActiveTab('table')}><FileText size={14} /> Detay Tablo</button>
        <button className={`${styles.navTab} ${activeTab==='map'?styles.navTabActive:''}`} onClick={()=>setActiveTab('map')}><MapIcon size={14} /> Harita</button>
        <button className={`${styles.navTab} ${activeTab==='ndvi'?styles.navTabActive:''}`} onClick={()=>setActiveTab('ndvi')} style={activeTab==='ndvi'?{}:{color:'#10b981'}}><Trees size={14} /> NDVI</button>
      </div>

      <div className={styles.mainContent}>
        {activeTab === 'reports' && (<>
          {renderChart()}
          {renderWaterLoss()}
          {renderReporting()}
          {renderTable()}
        </>)}
        {activeTab === 'compare' && renderHavzaCompare()}
        {activeTab === 'table' && renderTable()}
        {activeTab === 'map' && (
          <div className={styles.mapSection}>
            <div className={styles.mapSidebar}>
              <h4 className={styles.mapSidebarTitle}>Katmanlar</h4>

              <div className={styles.mapLayerGroup}>
                <div className={styles.mapLayerGroupTitle}>Havza Sınırları</div>
                {HAVZALAR.map((h,i) => (
                  <label key={h.id} className={styles.mapCheckRow}>
                    <input type="checkbox" checked={mapVisibleHavzalar.includes(h.id)} onChange={()=>setMapVisibleHavzalar(prev=>prev.includes(h.id)?prev.filter(x=>x!==h.id):[...prev,h.id])} />
                    <span className={styles.mapColorDot} style={{background:HAVZA_BOUNDARIES[i]?.color}} />
                    {h.name}
                  </label>
                ))}
              </div>

              <div className={styles.mapLayerGroup}>
                <div className={styles.mapLayerGroupTitle}>
                  Bölgeler
                  <button className={styles.mapSmallBtn} onClick={()=>{ const allIds = ILCELER.flatMap(i=>i.bolgeler.map(b=>b.id)); setMapVisibleBolgeler(prev=>prev.length===allIds.length?[]:allIds); }}>
                    {mapVisibleBolgeler.length > 0 ? 'Temizle' : 'Tümü'}
                  </button>
                </div>
                {ILCELER.map(ilce => (
                  <div key={ilce.id} className={styles.mapIlceGroup}>
                    <div className={styles.mapIlceLabel} onClick={()=>{
                      const bolgeIds = ilce.bolgeler.map(b=>b.id);
                      const allSelected = bolgeIds.every(id=>mapVisibleBolgeler.includes(id));
                      setMapVisibleBolgeler(prev => allSelected ? prev.filter(x=>!bolgeIds.includes(x)) : [...new Set([...prev,...bolgeIds])]);
                    }}>{ilce.name}</div>
                    {ilce.bolgeler.map(b => (
                      <label key={b.id} className={styles.mapCheckRow} style={{paddingLeft:16}}>
                        <input type="checkbox" checked={mapVisibleBolgeler.includes(b.id)} onChange={()=>setMapVisibleBolgeler(prev=>prev.includes(b.id)?prev.filter(x=>x!==b.id):[...prev,b.id])} />
                        <span style={{fontSize:11}}>{b.name}</span>
                      </label>
                    ))}
                  </div>
                ))}
              </div>

              <div className={styles.mapLayerGroup}>
                <label className={styles.mapCheckRow}>
                  <input type="checkbox" checked={mapShowParks} onChange={()=>setMapShowParks(!mapShowParks)} />
                  <span className={styles.mapColorDot} style={{background:'#ef4444'}} />
                  Parkları Göster
                </label>
                {mapShowParks && <p style={{fontSize:10,color:'#94a3b8',margin:'2px 0 0 20px'}}>Seçili bölgelerdeki parklar{mapVisibleBolgeler.length===0?' (tümü)':''}</p>}
              </div>

              <div className={styles.mapLayerGroup}>
                <div className={styles.mapLayerGroupTitle}>NDVI Uydu Analizi</div>
                {!geeReady ? (
                  <div style={{padding:'6px 0'}}>
                    <input style={{width:'100%',padding:'6px 8px',borderRadius:5,border:'1px solid #d1d5db',fontSize:11,marginBottom:6,boxSizing:'border-box'}} placeholder="GEE Project ID" value={geeProject} onChange={e=>setGeeProject(e.target.value)} />
                    <button onClick={handleConnectGEE} disabled={geeLoading} style={{width:'100%',padding:'6px',borderRadius:5,border:'none',cursor:geeLoading?'wait':'pointer',fontSize:11,fontWeight:600,background:geeLoading?'#94a3b8':'#10b981',color:'#fff'}}>
                      {geeLoading?'Baglaniyor...':'GEE Baglan'}
                    </button>
                    <p style={{fontSize:10,color:'#94a3b8',marginTop:4}}>Google Earth Engine ile uydu bazli NDVI analizi</p>
                  </div>
                ) : (
                  <>
                    <p style={{fontSize:11,color:'#22c55e',fontWeight:600,margin:'4px 0'}}>GEE Bagli</p>
                    <label className={styles.mapCheckRow}>
                      <input type="checkbox" checked={showNdviLayer} onChange={()=>setShowNdviLayer(!showNdviLayer)} />
                      <span className={styles.mapColorDot} style={{background:'#166534'}} />
                      NDVI Katmanini Goster
                    </label>
                    {Object.keys(ndviResults).length > 0 && (
                      <div style={{marginTop:6}}>
                        <p style={{fontSize:10,color:'#64748b',fontWeight:600,marginBottom:4}}>Analiz Sonuclari:</p>
                        {Object.entries(ndviResults).map(([key, r]) => (
                          <div key={key} onClick={()=>setNdviPanel(key)} style={{padding:'5px 8px',background:ndviPanel===key?'#eff6ff':'#f8fafc',borderRadius:5,marginBottom:3,cursor:'pointer',fontSize:11,border:ndviPanel===key?'1px solid #bfdbfe':'1px solid #f1f5f9'}}>
                            <div style={{fontWeight:600,color:'#1e293b'}}>{r.name}</div>
                            {!r.error && <div style={{color:getNdviColor(r.ndviMean)}}>NDVI: {r.ndviMean?.toFixed(3)} | {r.greenRatio}% yesil</div>}
                            {r.error && <div style={{color:'#ef4444',fontSize:10}}>{r.error}</div>}
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className={styles.mapMain}>
              <div className={styles.mapContainer}><div ref={mapContainerRef} className={styles.map} /></div>
              {ndviPanel && ndviResults[ndviPanel] && !ndviResults[ndviPanel].error && (
                <div style={{position:'absolute',bottom:16,right:16,width:340,background:'rgba(255,255,255,0.97)',borderRadius:12,boxShadow:'0 8px 32px rgba(0,0,0,0.15)',padding:16,zIndex:10,maxHeight:'60%',overflow:'auto'}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
                    <h4 style={{margin:0,fontSize:14,color:'#1e293b'}}>{ndviResults[ndviPanel].name}</h4>
                    <button onClick={()=>setNdviPanel(null)} style={{background:'none',border:'none',cursor:'pointer',fontSize:16,color:'#94a3b8'}}>✕</button>
                  </div>
                  {ndviLoading ? (
                    <p style={{color:'#64748b',fontSize:12,textAlign:'center',padding:16}}>Uydu verisi isleniyor...</p>
                  ) : (
                    <>
                      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:6,marginBottom:10}}>
                        <div style={{background:'#f0fdf4',borderRadius:8,padding:8,textAlign:'center'}}>
                          <div style={{fontSize:20,fontWeight:700,color:getNdviColor(ndviResults[ndviPanel].ndviMean)}}>{ndviResults[ndviPanel].ndviMean?.toFixed(3)}</div>
                          <div style={{fontSize:9,color:'#64748b'}}>Ort NDVI</div>
                        </div>
                        <div style={{background:'#f8fafc',borderRadius:8,padding:8,textAlign:'center'}}>
                          <div style={{fontSize:20,fontWeight:700,color:'#ef4444'}}>{ndviResults[ndviPanel].ndviMin?.toFixed(3)}</div>
                          <div style={{fontSize:9,color:'#64748b'}}>Min</div>
                        </div>
                        <div style={{background:'#f8fafc',borderRadius:8,padding:8,textAlign:'center'}}>
                          <div style={{fontSize:20,fontWeight:700,color:'#166534'}}>{ndviResults[ndviPanel].ndviMax?.toFixed(3)}</div>
                          <div style={{fontSize:9,color:'#64748b'}}>Max</div>
                        </div>
                      </div>
                      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:6,marginBottom:10}}>
                        <div style={{background:'#eff6ff',borderRadius:8,padding:8,textAlign:'center'}}>
                          <div style={{fontSize:16,fontWeight:700,color:'#2563eb'}}>{ndviResults[ndviPanel].greenAreaM2?.toLocaleString()}</div>
                          <div style={{fontSize:9,color:'#64748b'}}>Yesil Alan (m2)</div>
                        </div>
                        <div style={{background:'#fefce8',borderRadius:8,padding:8,textAlign:'center'}}>
                          <div style={{fontSize:16,fontWeight:700,color:'#ca8a04'}}>{ndviResults[ndviPanel].greenRatio}%</div>
                          <div style={{fontSize:9,color:'#64748b'}}>Yesil Oran</div>
                        </div>
                      </div>
                      <div style={{height:16,borderRadius:6,overflow:'hidden',background:'linear-gradient(90deg, #ef4444, #facc15, #22c55e, #166534)',position:'relative',marginBottom:4}}>
                        {(() => {
                          const r = ndviResults[ndviPanel];
                          const range = r.ndviMax - r.ndviMin;
                          const pos = range > 0 ? ((r.ndviMean - r.ndviMin) / range) * 100 : 50;
                          return <div style={{position:'absolute',left:`${pos}%`,top:0,bottom:0,width:2,background:'#1e293b',borderRadius:1}} />;
                        })()}
                      </div>
                      <div style={{display:'flex',justifyContent:'space-between',fontSize:9,color:'#94a3b8'}}>
                        <span>{ndviResults[ndviPanel].ndviMin?.toFixed(2)}</span>
                        <span style={{fontWeight:600,color:getNdviColor(ndviResults[ndviPanel].ndviMean)}}>{getNdviLabel(ndviResults[ndviPanel].ndviMean)}</span>
                        <span>{ndviResults[ndviPanel].ndviMax?.toFixed(2)}</span>
                      </div>
                      <div style={{marginTop:8,padding:'6px 8px',background:'#f8fafc',borderRadius:6,fontSize:10,color:'#64748b'}}>
                        <span>{ndviResults[ndviPanel].imageCount} uydu goruntusu | {ndviResults[ndviPanel].dateRange}</span><br/>
                        <span>Toplam alan: {ndviResults[ndviPanel].totalAreaM2?.toLocaleString()} m2 | Esik: {ndviResults[ndviPanel].threshold}</span>
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
        {activeTab === 'ndvi' && (
          <div style={{padding:24}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
              <div>
                <h3 style={{margin:0,color:'#1e293b',fontSize:18}}>Uydu Bazli NDVI Analizi</h3>
                <p style={{margin:'4px 0 0',color:'#64748b',fontSize:13}}>Sentinel-2 uydu goruntulerinden yesil alan ve bitki sagligi analizi</p>
              </div>
              {!geeReady ? (
                <div style={{display:'flex',gap:8,alignItems:'center'}}>
                  <input style={{padding:'8px 12px',borderRadius:6,border:'1px solid #d1d5db',fontSize:13,width:180}} placeholder="GEE Project ID" value={geeProject} onChange={e=>setGeeProject(e.target.value)} />
                  <button onClick={handleConnectGEE} disabled={geeLoading} style={{padding:'8px 16px',borderRadius:8,border:'none',cursor:geeLoading?'wait':'pointer',fontSize:13,fontWeight:600,background:geeLoading?'#94a3b8':'#10b981',color:'#fff',whiteSpace:'nowrap'}}>
                    {geeLoading?'Baglaniyor...':'GEE Baglan'}
                  </button>
                </div>
              ) : (
                <span style={{fontSize:12,color:'#22c55e',fontWeight:600,background:'#f0fdf4',padding:'6px 14px',borderRadius:20,border:'1px solid #bbf7d0'}}>GEE Bagli</span>
              )}
            </div>

            {!geeReady && (
              <div style={{background:'#eff6ff',borderRadius:12,padding:24,border:'1px solid #bfdbfe',marginBottom:20}}>
                <h4 style={{color:'#1d4ed8',margin:'0 0 8px'}}>Google Earth Engine Baglantisi Gerekli</h4>
                <p style={{fontSize:13,color:'#334155',margin:0,lineHeight:1.6}}>
                  NDVI analizi icin Google Earth Engine projenize baglanmaniz gerekir. Sag ustteki alana proje ID'nizi girip "GEE Baglan" butonuna basin.
                  Google hesabinizla oturum acmaniz istenecektir.
                </p>
              </div>
            )}

            {geeReady && (
              <>
                <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20}}>
                  {[
                    {range:'< 0',color:'#dc2626',label:'Su / Bos Alan',bg:'#fef2f2'},
                    {range:'0 - 0.2',color:'#f59e0b',label:'Zayif Bitki Ortusu',bg:'#fffbeb'},
                    {range:'0.2 - 0.4',color:'#22c55e',label:'Orta Yogunlukta Bitki',bg:'#f0fdf4'},
                    {range:'> 0.4',color:'#166534',label:'Yogun / Saglikli Bitki',bg:'#dcfce7'},
                  ].map((item,i) => (
                    <div key={i} style={{background:item.bg,borderRadius:10,padding:14,textAlign:'center',border:'1px solid #e2e8f0'}}>
                      <div style={{fontSize:22,fontWeight:700,color:item.color}}>{item.range}</div>
                      <div style={{fontSize:11,color:'#64748b',marginTop:4}}>{item.label}</div>
                    </div>
                  ))}
                </div>

                <div style={{background:'#fff',borderRadius:12,border:'1px solid #e2e8f0',padding:20,marginBottom:20}}>
                  <h4 style={{margin:'0 0 12px',color:'#1e293b'}}>Bolge/Park Secimi</h4>
                  <p style={{fontSize:12,color:'#64748b',marginBottom:12}}>Mevcut filtrelere gore secili bolgelerdeki parklarin NDVI analizi</p>
                  <div style={{display:'flex',flexWrap:'wrap',gap:8}}>
                    {(() => {
                      const parks = getAllParksInScope();
                      return parks.slice(0,20).map((p,i) => {
                        const cached = ndviResults[p.name];
                        return (
                          <button key={i} onClick={()=>{
                            const bc = BOLGE_COORDS[p.bolgeId];
                            if (bc) {
                              const coords = bc.bounds;
                              runNDVIForCoords(p.name, coords);
                            }
                          }} style={{padding:'6px 14px',borderRadius:8,border: cached ? `2px solid ${getNdviColor(cached.ndviMean)}` : '1px solid #e2e8f0',background: cached ? '#f8fafc' : '#fff',cursor:'pointer',fontSize:12,transition:'all .15s'}}>
                            <span style={{fontWeight:600}}>{p.name}</span>
                            {cached && !cached.error && <span style={{marginLeft:6,color:getNdviColor(cached.ndviMean),fontWeight:700}}>{cached.ndviMean?.toFixed(2)}</span>}
                          </button>
                        );
                      });
                    })()}
                  </div>
                  {getAllParksInScope().length > 20 && <p style={{fontSize:11,color:'#94a3b8',marginTop:8}}>+{getAllParksInScope().length - 20} park daha (filtre ile daraltabilirsiniz)</p>}
                </div>

                {Object.keys(ndviResults).length > 0 && (
                  <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill, minmax(280px, 1fr))',gap:16}}>
                    {Object.entries(ndviResults).map(([key, r]) => (
                      <div key={key} style={{background:'#fff',borderRadius:12,border:'1px solid #e2e8f0',padding:16,transition:'all .15s'}}>
                        <h5 style={{margin:'0 0 10px',color:'#1e293b',fontSize:14}}>{r.name}</h5>
                        {r.error ? (
                          <p style={{color:'#ef4444',fontSize:12}}>{r.error}</p>
                        ) : (
                          <>
                            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:6,marginBottom:10}}>
                              <div style={{background:'#f0fdf4',borderRadius:6,padding:6,textAlign:'center'}}>
                                <div style={{fontSize:18,fontWeight:700,color:getNdviColor(r.ndviMean)}}>{r.ndviMean?.toFixed(3)}</div>
                                <div style={{fontSize:9,color:'#64748b'}}>Ort NDVI</div>
                              </div>
                              <div style={{background:'#f8fafc',borderRadius:6,padding:6,textAlign:'center'}}>
                                <div style={{fontSize:14,fontWeight:600,color:'#2563eb'}}>{r.greenAreaM2?.toLocaleString()}</div>
                                <div style={{fontSize:9,color:'#64748b'}}>Yesil m2</div>
                              </div>
                              <div style={{background:'#fefce8',borderRadius:6,padding:6,textAlign:'center'}}>
                                <div style={{fontSize:14,fontWeight:600,color:'#ca8a04'}}>{r.greenRatio}%</div>
                                <div style={{fontSize:9,color:'#64748b'}}>Yesil Oran</div>
                              </div>
                            </div>
                            <div style={{height:10,borderRadius:4,overflow:'hidden',background:'linear-gradient(90deg, #ef4444, #facc15, #22c55e, #166534)'}}>
                              {(() => {
                                const range = r.ndviMax - r.ndviMin;
                                const pos = range > 0 ? ((r.ndviMean - r.ndviMin) / range) * 100 : 50;
                                return <div style={{position:'relative'}}><div style={{position:'absolute',left:`${pos}%`,top:-1,width:2,height:12,background:'#1e293b',borderRadius:1}} /></div>;
                              })()}
                            </div>
                            <div style={{display:'flex',justifyContent:'space-between',fontSize:9,color:'#94a3b8',marginTop:2}}>
                              <span>{r.ndviMin?.toFixed(2)}</span>
                              <span style={{fontWeight:600,color:getNdviColor(r.ndviMean)}}>{getNdviLabel(r.ndviMean)}</span>
                              <span>{r.ndviMax?.toFixed(2)}</span>
                            </div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>

      <div className={styles.footer}>
        <button className={`${styles.headerBtn} ${styles.legacyBtn}`} onClick={()=>setShowLegacy(true)}>Eski Dashboard'a Geç</button>
      </div>
    </div>
  );
};

export default AskiDashboard;
